/* eslint-disable camelcase */
export const uk = {
  AdminDashboard: {
    expiringLicenses: {
      popupHeader: "Увага",
      title:
        "Список облікових записів, у яких ліцензія закінчується протягом %cnt% днів",
      understandButton: "Зрозуміло",
    },
    ActivitiesList: {
      labStatus: {
        error: "помилка",
        success: "успішно",
      },
      labels: {
        action: "Дія",
        context: "Опис",
        date: "Дата",
        errorMsg: "Опис помилки",
        executor: "Виконавець",
        status: "Статус",
      },
    },
    Licence: {
      deletePopup: {
        confirmationText: "Так, я хочу видалити ліцензію",
        contentText:
          "Після видалення ліцензії буде неможливо призначати обстеження",
        headerText: "Ви впевнені, що хочете видалити ліцензію?",
      },
      labels: {
        expireDate: "Термін дії ліцензії",
        licenseDate: "Дата видачі ліцензії",
        methodologyList: "Доступні методики",
        testsList: "Доступні тести",
      },
    },
    PsychLab: {
      anonymizePopup: {
        headerText: "Ви впевнені, що хочете анонімізувати дані клієнта?",
        contentText:
          "Усі обстеження та дані обстежуваних будуть анонімізовані та перенесені до облікового запису Psychometric (нові та незавершені обстеження будуть видалені). Операцію не можна скасувати. Ви хочете продовжити?",
        confirmationText: "Так, я хочу анонімізувати дані",
      },
      deletePopup: {
        confirmationText: "Так, я хочу видалити обліковий запис клієнта",
        contentText:
          "Після видалення облікового запису клієнта буде неможливо відновити дані",
        headerText: "Ви впевнені, що хочете видалити обліковий запис клієнта?",
      },
    },
    PsychLabManagment: {
      PsychLabView: {
        labels: {
          details: "Деталі",
          download: "Завантажити",
          edit: "Редагувати",
          generate: "Згенерувати",
          name: "Назва тесту",
          nameFile: "Ім'я файлу",
          print: "Друк",
          result: "Результат",
          type: "Тип документа",
        },
        tabs: {
          activityAction: "назва дії",
          activityContext: "опис",
          activityDate: "дата",
          activityExecutor: "виконавець",
          activityId: "ID",
          activityLogs: "Журнал дій",
          activityLogsFile: "журнал_дій",
          activityStatus: "статус",
          license: "Ліцензія",
          psychLabData: "Дані клієнта",
          stats: "Статистика",
          theme: "Зовнішній вигляд",
          parameters: "Параметри",
          priceList: "Цінник",
          users: "Користувачі",
        },
        parameters: {
          header: "Параметри клієнта",
          noParameters:
            "Немає доступних параметрів для цього клієнта. Перевірте, чи активна ліцензія.",
        },
      },
      breadcrumbs: {
        add: "Додати обліковий запис клієнта",
        addLicense: "Додати ліцензію",
        addUser: "Додати обліковий запис користувача",
        dashboard: "Панель користувача",
        edit: "Редагувати обліковий запис клієнта",
        editLicense: "Редагувати ліцензію",
        editUser: "Редагувати обліковий запис користувача",
        psychLabs: "Картотека клієнтів",
      },
      header: {
        add: "Додати обліковий запис клієнта",
        addLicense: "Додати ліцензію",
        addUser: "Додати обліковий запис користувача",
        edit: "Редагувати обліковий запис клієнта",
        editLicense: "Редагувати ліцензію",
        editUser: "Редагувати обліковий запис користувача",
      },
    },
    PsychologicalLabsList: {
      labStatus: {
        disabled: "неактивний",
        enabled: "активний",
      },
      labels: {
        all: "всі",
        clientId: "ID клієнта",
        createDate: "Дата створення",
        details: "Деталі",
        examinationsCnt: "Кількість обстежень",
        examineesCnt: "Кількість обстежуваних",
        expireDate: "Термін дії облікового запису",
        licenseExpireDate: "Термін дії ліцензії",
        moreThen: "більше ніж",
        name: "Назва клієнта",
        of: "з",
        psychCnt: "Кількість користувачів",
        status: "Статус",
        systemAccount: "системний обліковий запис",
        taskPerPage: "Рядків на сторінці:",
        usersCnt: "Кількість користувачів",
      },
      expiryWarningTooltip:
        "Термін дії ліцензії або облікового запису закінчується протягом %count% днів",
      expiredWarningTooltip: "Термін дії ліцензії або облікового запису минув",
      inactiveAccountTooltip: "Обліковий запис неактивний",
    },
    StatsList: {
      statFileName: "статистика_обстежень.xlsx",
    },
    UsersList: {
      deletePopup: {
        confirmationText: "Так, я хочу видалити обліковий запис користувача",
        contentText:
          "Після видалення облікового запису користувача його неможливо буде відновити",
        headerText:
          "Ви впевнені, що хочете видалити обліковий запис користувача?",
      },
      labStatus: {
        adminRole: "адміністратор",
        disabled: "неактивний",
        enabled: "активний",
        superUserRole: "супер адміністратор",
        userBaseRole: "реєстратор",
        userRole: "користувач",
      },
      labels: {
        email: "Email",
        examinationCnt: "Número de exámenes (todos / asignados / completados)",
        examinationCnt1: "Кількість обстежень",
        examinationCnt2: "всі: ",
        examinationCnt3: "призначені: ",
        examinationCnt4: "виконані: ",
        examineeCnt: "Кількість учасників",
        firstName: "Ім'я",
        isActive: "Статус",
        isStaff: "Роль",
        lastName: "Прізвище",
      },
      toolTip: {
        move: "перемістити обстеження і папки",
        delete: "видалити",
        edit: "редагувати",
      },
    },
    emptyState: {
      header: "Облікові записи клієнтів ще не додано",
      info: "Щоб побачити список клієнтів, додайте хоча б один обліковий запис.",
    },
    emptyStateLicense: {
      header: "Ліцензії ще не додано",
      info: "Щоб побачити ліцензію, додайте її.",
    },
    emptyStateUsers: {
      header: "Облікові записи користувачів ще не додано",
      info: "Щоб побачити список користувачів, додайте хоча б один обліковий запис.",
    },
    header: "Картотека клієнтів",
    showInactiveAccounts: "Показати неактивні облікові записи",
    kebabMenu: {
      print: "Роздрукувати контракт",
      profile: "Перейти до профілю обстежуваного",
    },
  },
  AdminSearchEngine: {
    enterFilter:
      "Ви можете шукати за назвою, ID, адресою, податковим номером, датою створення, датою закінчення дії облікового запису клієнта у форматі РРРР-ММ-ДД, ім'ям, прізвищем, електронною поштою користувача, датою закінчення дії ліцензії у форматі РРРР-ММ-ДД, методологією, тестом.",
    header: "Пошук клієнтів",
    noResults: "Немає результатів пошуку",
    noResultsForFilter:
      "Не знайдено клієнтів, що відповідають введеним вимогам.",
    placeholderDesktop:
      "назва, ID, адреса, податковий номер, дата створення, дата закінчення дії облікового запису клієнта у форматі РРРР-ММ-ДД, ім'я, прізвище, електронна пошта користувача, дата закінчення дії ліцензії, методологія, тест",
    placeholderMobile: "Пошук",
    searchForExaminees: "Пошук клієнтів",
  },
  ArchiveExaminationList: {
    emptyState: {
      info: "Немає архівних обстежень, призначених цьому учаснику",
    },
  },
  Backend: {
    Could_not_bind_users_PsychologicalLab_with_the_directory:
      "Не вдалося пов'язати заклад користувача з папкою.",
    Could_not_bind_users_PsychologicalLab_with_the_examinee:
      "Не вдалося пов'язати заклад користувача з обстежуваним.",
    Directory_has_related_Examinees:
      "Неможливо видалити Папку: Папка містить пов'язаних обстежуваних.",
    Directory_with_given_name_already_exists:
      "Папка з вказаною назвою вже існує.",
    Examination_Card_does_not_have_a_defined_NormSet:
      "Картка обстеження не має призначеної норми обстеження.",
    Examinee_with_the_given_id_exists_in_this_psychological_lab:
      "Обстежуваний із вказаним ID вже існує в базі даних.",
    Generated_ID_conflict:
      "Помилка генерації ідентифікатора для досліджуваного.",
    Incorrect_credentials: "Невірний пароль.",
    Invalid_token_Please_regenerate_password_reset_link:
      "Недійсний токен, будь ласка, згенеруйте нове посилання для скидання пароля.",
    Legacy_data_instance_not_found: "Архівні дані не знайдено.",
    Legacy_data_validation_failed: "Помилка перевірки архівних даних.",
    Ongoing_examination: "Неможливо видалити Обстеження. Обстеження в процесі.",
    User_has_related_Examinations_or_Directories:
      "Неможливо видалити Користувача: У користувача є пов'язані обстеження або папки.",
    The_Examinee_has_related_Examinations:
      "Неможливо видалити Обстежуваного: В обстежуваного є пов'язані обстеження.",
    The_new_pin_cannot_be_the_same_as_the_previous_one:
      "Новий ПІН-код не може бути таким самим, як попередній.",
    The_password_cannot_be_the_same_as_the_previous_one:
      "Пароль не може бути таким самим, як попередній.",
    Token_not_recognized: "Токен не розпізнано.",
    Unable_to_delete_default_directory:
      "Неможливо видалити Папку за замовчуванням.",
    Unable_to_parse_Examination_Aim: "Помилка перевірки Мети Обстеження.",
    Unable_to_parse_Occupational_Medicine_Basic_Info_data:
      "Помилка перевірки даних Медицини Праці.",
    Unrecognized_email:
      "Адреса електронної пошти не розпізнана або обліковий запис не активовано.",
    Unrecognized_proxy_error_occurred_while_fetching_legacy_data:
      "Виникла нерозпізнана помилка при отриманні архівних даних.",
    Unrecognized_token_Please_regenerate_password_reset_link:
      "Нерозпізнаний токен, будь ласка, згенеруйте нове посилання для скидання пароля.",
    User_activation_code_does_not_exist: "Вказаний код активації не існує.",
    User_activation_code_has_already_been_used:
      "Код активації вже використано.",
    User_with_given_id_does_not_exist: "Користувач із вказаним ID не існує.",
    Validation_failed: "Перевірка введених даних не вдалася.",
  },
  Buttons: {
    accept: "Погоджуюсь",
    addDirectory: "Додати папку",
    addExaminee: "Додати обстежуваного",
    addMobileExaminee: "Додати",
    addPsychLab: "Додати обліковий запис клієнта",
    addPsychLabLic: "Додати ліцензію",
    addPsychUser: "Додати обліковий запис користувача",
    addPsychUserMobile: "Додати користувача",
    addUser: "Додати обліковий запис користувача",
    alreadyAssigned: "Призначено",
    alreadyAssignedExamination: "Обстеження в процесі",
    assign: "Призначити",
    assignExamination: "Призначити обстеження",
    back: "Назад",
    backToLogin: "Повернутися на сторінку входу",
    begin: "Розпочати",
    cancel: "Скасувати",
    change: "Змінити",
    clear: "Очистити",
    close: "Закрити",
    confirm: "Підтвердити",
    continue: "Далі",
    createExamination: "Призначити обстеження",
    delete: "Видалити",
    anonymize: "Анонімізувати",
    deleteExaminee: "Видалити обстежуваного",
    deleteExaminees: "Видалити обстежуваних",
    anonymizePsychLab: "Анонімізувати дані",
    deletePsychLab: "Видалити обліковий запис клієнта",
    deletePsychLabLic: "Видалити ліцензію",
    disable2FA: "Вимкнути двофакторну автентифікацію",
    downloadAll: "Завантажити все",
    edit: "Редагувати",
    editExaminee: "Редагувати обстежуваного",
    editPsychLab: "Редагувати обліковий запис клієнта",
    editPsychLabLic: "Редагувати ліцензію",
    editPsychLabUser: "Редагувати обліковий запис користувача",
    enable2FA: "Увімкнути двофакторну автентифікацію",
    examinationWithLawBase: "Обстеження з правовою підставою",
    examinationWithNoLawBase: "Обстеження без правової підстави",
    exit: "Вийти",
    exportActivities: "Експорт до файлу XLS",
    exportResults: "Згенерувати експорт",
    generate: "Згенерувати",
    generateAndPrint: "Згенерувати та роздрукувати",
    go: "Перейти",
    goToDashboard: "Перейти до панелі користувача",
    importExaminees: "Імпортувати досліджуваних",
    login: "Увійти",
    loginPsychLab: "Увійти до облікового запису клієнта",
    move: "Перемістити",
    moveExaminee: "Перемістити обстежуваного",
    moveExaminees: "Перемістити обстежуваних",
    examineesIdsList: "Завантажити список обстежуваних",
    ok: "Гаразд",
    print: "Роздрукувати",
    printContract: "Роздрукувати контракт",
    save: "Зберегти",
    saveAndInvate: "Зберегти та запросити",
    saveAndPrint: "Зберегти та роздрукувати",
    savePassword: "Зберегти пароль",
    savePin: "Зберегти ПІН",
    saveSettings: "Зберегти налаштування",
    search: "Пошук",
    sendEmail: "Надіслати повідомлення",
    sendLink: "Надіслати посилання",
    setNewPassword: "Встановити новий пароль",
    setPassword: "Встановити пароль",
    setPin: "Встановити ПІН",
    showActivities: "Показати",
    skipTests: "Пропустити тести",
    understood: "Зрозуміло",
    unblockedExam: "Розблокувати обстеження",
    enable2FAIcon: "Увімкнути двофакторну автентифікацію",
    disable2FAIcon: "Вимкнути двофакторну автентифікацію",
    openFolder: "Відкрити",
  },
  Common: {
    deleteExamineePopup: {
      header: "Ви впевнені, що хочете видалити обстежуваного?",
      text: "Після видалення обстежуваного відновлення даних буде неможливим",
      confirmationText: "Так, я хочу видалити обстежуваного",
    },
    deleteExamineesPopup: {
      header: "Ви впевнені, що хочете видалити вибраних обстежуваних?",
      text: "Після видалення обстежуваних відновлення даних буде неможливим",
      confirmationText: "Так, я хочу видалити обстежуваних",
    },
    deleteExamineeWithExamPopup: {
      header:
        "Ви впевнені, що хочете видалити обстежуваного разом з обстеженнями?",
      text: "Після видалення обстежуваного разом з обстеженнями відновлення даних буде неможливим",
      confirmationText:
        "Так, я хочу видалити обстежуваного разом з обстеженнями",
    },
    deleteExamineesWithExamPopup: {
      header:
        "Ви впевнені, що хочете видалити вибраних обстежуваних разом з обстеженнями?",
      text: "Після видалення обстежуваних разом з обстеженнями відновлення даних буде неможливим",
      confirmationText:
        "Так, я хочу видалити обстежуваних разом з обстеженнями",
    },
    logAdminAsUserPopup: {
      header: "Помилка",
      text: "Не вдалося увійти до облікового запису клієнта",
    },
    menu: {
      breadcrumbsPsychLab: "Записи клієнтів",
      contact: "Допомога",
      dashboard: "Панель користувача",
      emailSender: "Відправлення повідомлення",
      exportResults: "Експорт результатів",
      examineeRegistry: "Реєстр обстежуваних",
      folders: "Записи обстежуваних",
      importExaminees: "Імпорт досліджуваних",
      logout: "Вийти",
      psychlabs: "Записи клієнтів",
      search: "Пошук",
      settings: "Налаштування",
      priceList: "Цінник",
      summary: "Реєстр обстежуваних",
    },
    seo: {
      addExaminee: "Додати обстежуваного",
      addPsychLab: "Додати обліковий запис клієнта",
      addPsychLabLic: "Додати ліцензію",
      dashboard: "Панель користувача",
      editExaminee: "Редагувати обстежуваного",
      emailSender: "Відправлення повідомлення",
      examinationAssignment: "Призначення обстеження з правовою підставою",
      examinationCard: "Картка Обстеження",
      exportResults: "Експорт результатів",
      folders: "Картотека обстежуваних",
      helpdesk: "Допомога",
      helpdeskDocuments: "Документи допомоги",
      judgement: "Висновок",
      login: "Вхід",
      onboarding: "Онбординг",
      report: "Звіт",
      resetPassword: "Скидання пароля",
      search: "Пошук",
      setNewPassword: "Встановлення нового пароля",
      settings: "Налаштування",
      priceList: "Цінник",
    },
    twoFactorAuth: "Двофакторна автентифікація",
    warningPopup: {
      header: "Ви впевнені, що хочете вийти?",
      headerSave: "Будь ласка, заповніть усі обов'язкові поля!",
      promptLogout:
        "Ви будете автоматично вийдете з системи через PROMPT_TIME_MINUTES хвилину через відсутність активності.",
      promptLogoutCountdown:
        "Ви будете автоматично вийдете з системи через COUNTDOWN_TIME через відсутність активності.",
      logoutWarningTitle: "Ваша сесія незабаром закінчиться",
      promptLogoutInfo:
        "Через відсутність активності ви будете автоматично вийдете з системи через хвилину.",
      stayLoggedIn: "Продовжити сесію",
      logoutNow: "Вийти зараз",
      text: "Внесені вами зміни не будуть збережені",
      textSave: "Обов'язкові поля можуть також знаходитися на інших вкладках",
    },
  },
  Contact: {
    header: "Технічна підтримка",
  },
  WhatsNew: {
    closeButton: "Зрозуміло",
  },
  LicenseExpire: {
    popup: {
      header: "Увага!",
      messageManyDaysBold:
        "Термін дії ліцензії або облікового запису закінчиться через %cnt% дн.",
      messageOneDayBold:
        "Термін дії ліцензії або облікового запису закінчиться через %cnt% дн.",
      messageRest:
        "Зв'яжіться з нами для збереження безперервності роботи та доступу до всіх функцій системи.",
      understandButton: "Зрозуміло",
      dontShowAgain: "Більше не показувати",
    },
    expiredPopup: {
      header: "Ліцензія закінчилась",
      message:
        "Термін дії вашої ліцензії на проведення тестів у системі Optimis закінчився.",
      okButton: "OK",
    },
  },
  Cookies: {
    consent:
      "Для надання послуг найвищої якості ми використовуємо файли cookie. Використання нашого сайту означає, що вони будуть розміщені на вашому пристрої. Ви можете змінити налаштування вашого браузера в будь-який час.",
    cookiePolicy: {
      moduleText1:
        "Сервіс використовує файли cookie. У наступному документі ми інформуємо про використання файлів cookie в сервісі Optimis.",
      moduleText10:
        "Меню > Налаштування > Конфіденційність > Файли cookie – виберіть відповідну опцію.",
      moduleText2:
        "Файли cookie - це невеликі фрагменти тексту, коду, які надсилаються до браузера і які браузер надсилає назад. Деякі файли cookie іноді зберігаються на певному пристрої під час перегляду сервісу Optimis. Існують різні типи файлів cookie. Файли cookie, що використовуються в сервісі Optimis, були розділені на такі категорії:\n      a. необхідні файли cookie\n      b. функціональні\n      c. аналітичні",
      moduleText3:
        "a. Файли cookie, які необхідні для використання сервісу Optimis, служать, зокрема, для забезпечення стабільності його функціонування (вимірюють трафік і захищають нас від перевантаження). Ці файли cookie абсолютно необхідні для того, щоб сервіс Optimis міг надавати послуги, та/або виключно з метою передачі послуг та/або сервісу Optimis.\n      b. Функціональні файли cookie - запам'ятовування вибраних налаштувань конфіденційності, заповнень онлайн-форм, запам'ятовування налаштувань веб-сайту.",
      moduleText4:
        "Під час відвідування сайту www.gov.pl буде відображено повідомлення, що інформує про використання файлів cookie.",
      moduleText5:
        "У більшості інтернет-браузерів можна: видаляти файли cookie з жорсткого диска комп'ютера (з налаштувань браузера), блокувати всі надіслані файли cookie або встановити попередження перед їх збереженням на диску.\n      Слід мати на увазі, що зміни налаштувань цих файлів, що полягають в обмеженні їх використання, можуть вплинути на деякі функціональні можливості, доступні на веб-сайтах, що їх використовують.\n      Нижче ми вказуємо спосіб зміни налаштувань cookie в найбільш популярних браузерах:",
      moduleText6:
        "Меню > Налаштування > Конфіденційність та безпека – виберіть відповідну опцію.",
      moduleText7:
        "Меню > Налаштування > Файли cookie та дозволи сайту – виберіть відповідну опцію.",
      moduleText8:
        "Меню > Налаштування > Конфіденційність та безпека > Куки та дані сайтів – виберіть відповідну опцію.",
      moduleText9:
        "Меню > Налаштування > Конфіденційність та безпека – виберіть відповідну опцію.",
      moduleTitle1: "1. Вступ",
      moduleTitle10: "Safari",
      moduleTitle2: "2. Що таке файли cookie?",
      moduleTitle3: "3. Які файли cookie ми використовуємо?",
      moduleTitle4: "4. Згода на використання файлів cookie",
      moduleTitle5: "5. Зміна налаштувань файлів cookie",
      moduleTitle6: "Google Chrome",
      moduleTitle7: "Internet Explorer",
      moduleTitle8: "Mozilla Firefox",
      moduleTitle9: "Opera",
      title: "Політика щодо файлів cookie",
    },
    header: "Дозвіл на використання cookies",
    policy: "Політика щодо файлів cookie",
    showPolicy: "Переглянути політику щодо файлів cookie",
  },
  Dashboard: {
    emptyState: {
      header: "Немає нещодавно доданих обстежуваних",
      info: "Щоб побачити список обстежуваних, додайте хоча б одного.",
    },
    footer: {
      day: "день",
      days: "днів",
      lastFailedLogin: "Останній невдалий вхід",
      lastLogin: "Останній вхід",
      passwordExpired: "Термін дії вашого пароля закінчиться через",
      versionLabel: "Версія",
    },
    header: "Нещодавно додані люди",
    kebabMenu: {
      print: "Роздрукувати контракт",
      profile: "Перейти до профілю обстежуваного",
    },
  },
  Directory: {
    defaultFolderName: "Папка за замовчуванням",
    emptyState: {
      header: "У вибраній папці немає обстежуваних",
      info: "Щоб побачити список обстежуваних у папці, додайте хоча б одного обстежуваного",
    },
    header: "Картотека обстежуваних",
    kebabMenu: {
      addDirectory: "Додати папку",
      addExaminee: "Додати обстежуваного",
      delete: "Видалити папку",
      edit: "Змінити назву папки",
    },
    labels: {
      examineeCount: "Люди",
      name: "Назва папки",
      owner: "Власник",
    },
    popup: {
      create: "Введіть назву папки",
      edit: "Змінити назву папки",
    },
    popups: {
      delete: {
        confirmationHeader: "Ви впевнені, що хочете видалити папку?",
        confirmationText: "Після видалення папку неможливо буде відновити.",
        confirmationCheckboxLabel: "Так, я хочу видалити теку",
      },
    },
  },
  DirectoryPreview: {
    breadcrumbs: "Картотека обстежуваних",
    headerPopup: "Перемістити обстежуваних",
    kebabMenu: {
      delete: "Видалити обстежуваного",
      edit: "Редагувати дані обстежуваного",
      move: "Перемістити обстежуваного",
    },
    labels: {
      firstName: "Ім'я",
      lastModification: "Остання активність",
      lastName: "Прізвище",
      peselSlashIdentifier: "ІПН / Ідентифікатор",
    },
  },
  MoveExamAndFoldersPopup: {
    header: "Перемістити обстеження та папки",
    userInfo: "Дані користувача",
    examinations: "Кількість обстежень",
    examAll: "усього обстежень",
    examAssign: "призначено обстежень",
    examDone: "виконано обстежень",
    directories: "Папки користувача",
    noDirectories: "Немає папок",
    selectTargetUser:
      "Виберіть користувача, якому ви хочете перенести обстеження та папки",
    selectTargetUserLabel: "Цільовий користувач",
    noActiveUsers: "Немає активних користувачів",
    moveButton: "Перемістити",
  },
  DocumentationManagement: {
    ExaminationCard: {
      examinationCourse: {
        addExaminationExtendedResults: "Додати додатковий результат",
        careerHistory: "Історія роботи",
        cognitiveExtendedResultsHeader:
          "Оцінка та опис інтелектуальних здібностей та пізнавальних процесів - додаткові результати",
        cognitiveResultsHeader:
          "Оцінка та опис інтелектуальних здібностей та пізнавальних процесів обстежуваного (в рамках рекомендованої методики)",
        conclusions: "Висновки",
        conclusionsRecomendation: "Висновки та рекомендації",
        deletePopup: {
          confirmationText: "Так, я хочу видалити результат",
          contentText:
            "Після видалення результату можна відновити його початковий вміст шляхом оновлення даних",
          headerText: "Ви впевнені, що хочете видалити цей результат?",
        },
        examinationExtendedResultsHeader: "Назва тесту та додаткові результати",
        examinationExtendedResultsT2WHeader: "Додатково",
        examinationResultsHeader:
          "Назва тесту та результати (в рамках рекомендованої методики)",
        examinationResultsT2WHeader: "Рекомендована методика",
        forcedUpdateBody:
          "Для розблокування форми заповніть Опитування для Обстеження, виберіть стандарт у вкладці Обстежуваний та оновіть Картку Обстеження даними з Опитування та Результатами.",
        forcedUpdateHeader:
          "Оновити Картку Обстеження даними з Опитування та Результатами",
        header: "Дані прямого опитування та спостереження за обстежуваним",
        methodology: "Методи обстеження та результати",
        occupationalMedicineAdditionalInfo:
          "Додаткова інформація - Медицина праці",
        personalityExtendedResultsHeader:
          "Оцінка та опис особистості обстежуваного, включаючи функціонування в складних ситуаціях та соціальну зрілість - додаткові результати",
        personalityResultsHeader:
          "Оцінка та опис особистості обстежуваного, включаючи функціонування в складних ситуаціях та соціальну зрілість (в рамках рекомендованої методики)",
        psychomotorExtendedResultsHeader:
          "Психомоторні показники - додаткові результати",
        psychomotorResultsHeader:
          "Психомоторні показники (в рамках рекомендованої методики)",
        recommendations: "Рекомендації",
      },
      examinee: {
        aim: "Мета обстеження",
        chosenNormSet: "Стандарт, що застосовується при обстеженні",
        entityDirectingToExamination: "Направляюча організація",
        examinationDate: "Дата обстеження",
        previousExaminationDate: "Дата попереднього обстеження",
        t2dAim: {
          drivingInstructorAim:
            "Визначення відсутності або наявності протипоказань до виконання обов'язків інструктора/екзаменатора/інструктора з техніки водіння.",
          drivingVehiclesAim:
            "Визначення відсутності або наявності протипоказань до керування транспортними засобами.",
          emergencyDriverAim:
            "Визначення відсутності або наявності протипоказань до керування спецтранспортом або інкасаторським транспортом.",
          professionalDriverAim:
            "Визначення відсутності або наявності протипоказань до роботи на посаді водія.",
        },
      },
      fetchUpdated: "Оновити даними опитування та результатами",
      header: "Картка обстеження",
      headerTEST2ARMS: "Картка обстеження TEST2ARMS",
      headerTEST2DRIVE: "Картка обстеження TEST2DRIVE",
      headerTEST2SAFE: "Картка обстеження TEST2SAFE",
      headerTEST2WORK: "Картка обстеження TEST2WORK",
      judgment: {
        judgment: "Зміст висновку",
        justification: "Обґрунтування висновку",
        justificationText: "Зміст обґрунтування",
        recommendations: "Рекомендації",
        result: "Результат психологічного обстеження",
        sent: "Висновок/копію висновку надіслано, якщо застосовно",
        t2d: {
          existing: "наявні",
          lack: "відсутні",
          questions: {
            drivingInstructorContraindication:
              "Протипоказання до виконання обов'язків інструктора/екзаменатора/інструктора з техніки водіння.",
            drivingVehiclesContraindication:
              "Протипоказання до керування транспортними засобами.",
            emergencyVehicleDriverContraindication:
              "Протипоказання до керування спецтранспортом або інкасаторським транспортом.",
            professionalDriverContraindication:
              "Протипоказання до роботи на посаді водія.",
          },
        },
        to: "до",
      },
      tabs: {
        courseOfExamination: "Хід обстеження",
        examinee: "Обстежуваний",
        results: "Результати психологічного обстеження",
      },
      tooltipFetchUpdated:
        "Ця дія видалить усі незбережені зміни з Ходу обстеження",
      tooltipFetchUpdatedDisabled:
        "Для розблокування дії виберіть стандарт обстеження.",
    },
    consultation: {
      breadcrumbs: "Психологічна консультація",
      examineeData: "Дані обстежуваного",
      statement: "засвідчую",
    },
    emptyState: {
      header: "Обстеження не завершено",
    },
    judgment: {
      ART_1: "ст. 39к ч. 3 п. 1",
      ART_2: "ст. 39к ч. 3 п. 2",
      appeal: "На цей висновок може бути подана апеляція до",
      appealDate: "Протягом",
      appealDay: "Протягом",
      appealDay2: "днів з моменту отримання",
      appealDayTlt: "Кількість днів",
      civilExplosives: {
        false:
          "виявляє порушення психологічного функціонування і тому не може здійснювати діяльність з придбання та зберігання вибухових матеріалів цивільного призначення",
        true: "не виявляє порушень психологічного функціонування і тому може здійснювати діяльність з придбання та зберігання вибухових матеріалів цивільного призначення",
      },
      drivingExaminer: {
        false:
          "наявні протипоказання до виконання обов'язків інструктора/екзаменатора/інструктора з техніки водіння",
        true: "відсутні протипоказання до виконання обов'язків інструктора/екзаменатора/інструктора з техніки водіння",
      },
      drivingInstructor: {
        false:
          "наявні протипоказання до виконання обов'язків інструктора/екзаменатора/інструктора з техніки водіння",
        true: "відсутні протипоказання до виконання обов'язків інструктора/екзаменатора/інструктора з техніки водіння",
      },
      drivingLicense: "Щодо посвідчення водія категорії",
      drivingVehicles: {
        false:
          "наявні психологічні протипоказання до керування транспортними засобами",
        true: "відсутні психологічні протипоказання до керування транспортними засобами",
      },
      emergencyVehicleDriver: {
        false:
          "наявні протипоказання до керування спецтранспортом або інкасаторським транспортом",
        true: "відсутні протипоказання до керування спецтранспортом або інкасаторським транспортом",
      },
      examiner_ART_1: "ст. 34 ч. 5 п. 1",
      examiner_ART_2: "ст. 34 ч. 5 п. 2",
      firearmLicense: {
        false:
          "належить до осіб, зазначених у ст. 15 ч. 1 п. 3 закону від 21 травня 1999 р. про зброю та боєприпаси і не може володіти зброєю",
        true: "не належить до осіб, зазначених у ст. 15 ч. 1 п. 3 закону від 21 травня 1999 р. про зброю та боєприпаси і може володіти зброєю",
      },
      header: {
        base: "Висновок",
        baseAppeal: "Апеляційний висновок",
        baseAppealFooter: "Цей висновок є остаточним.",
        civilExplosives: "Ліцензована діяльність - для цивільного використання",
        civilExplosivesAppeal:
          "Ліцензована діяльність - для цивільного використання - апеляція",
        driver: "Керування транспортними засобами",
        drivingExaminer: "Екзаменатор",
        drivingInstructor: "Інструктор",
        emergencyVehicleDriver: "Водій спецтранспорту",
        firearmLicense: "Дозвіл на зброю",
        militaryExplosives:
          "Ліцензована діяльність - військового або поліцейського призначення",
        occupationalMedicine: "Медицина праці",
        physicalProtection: "Працівник охорони",
        profesionalDriver: "Посада водія",
      },
      isAppealTitle: "АПЕЛЯЦІЙНИЙ ВИСНОВОК",
      judgmentNumber: "Психологічний висновок №",
      judgmentNumberAppeal: "Психологічний висновок №",
      legalBais: "Правова підстава обстеження",
      militaryExplosives: {
        false:
          "виявляє істотні порушення психологічного функціонування, що перешкоджають здійсненню або керуванню господарською діяльністю у сфері виробництва та обігу вибухових матеріалів, зброї, боєприпасів та виробів і технологій військового або поліцейського призначення",
        true: "не виявляє істотних порушень психологічного функціонування, що перешкоджають здійсненню або керуванню господарською діяльністю у сфері виробництва та обігу вибухових матеріалів, зброї, боєприпасів та виробів і технологій військового або поліцейського призначення",
      },
      nextLegalBasis: "Правова підстава наступного обстеження:",
      occupationalMedicine: {
        false: "наявні психологічні протипоказання до",
        justification: "Обґрунтування",
        true: "відсутні психологічні протипоказання до",
      },
      occupationalMedicineStatement: "Встановлюю*",
      physicalProtection: {
        false:
          "не має здатності виконувати обов'язки працівника фізичної охорони",
        true: "має здатність виконувати обов'язки працівника фізичної охорони",
      },
      professionalDriver: {
        false:
          "наявні психологічні протипоказання до виконання роботи на посаді водія",
        true: "відсутні психологічні протипоказання до виконання роботи на посаді водія",
      },
      remarks: "Примітки",
      statement: "Засвідчую*",
      statementThat: "Засвідчую, що",
    },
    names: {
      CivilExplosivesJudgment:
        "Висновок про зброю та вибухові речовини для цивільного використання",
      CivilExplosivesJudgmentTEST2ARMS:
        "Висновок про зброю та вибухові речовини для цивільного використання",
      CivilExplosivesJudgmentTEST2DRIVE:
        "Висновок про зброю та вибухові речовини для цивільного використання",
      CivilExplosivesJudgmentTEST2SAFE:
        "Висновок про зброю та вибухові речовини для цивільного використання",
      CivilExplosivesJudgmentTEST2WORK:
        "Висновок про зброю та вибухові речовини для цивільного використання",
      DriverJudgment: "Висновок на керування транспортними засобами",
      DriverJudgmentTEST2ARMS: "Висновок на керування транспортними засобами",
      DriverJudgmentTEST2DRIVE: "Висновок на керування транспортними засобами",
      DriverJudgmentTEST2SAFE: "Висновок на керування транспортними засобами",
      DriverJudgmentTEST2WORK: "Висновок на керування транспортними засобами",
      DrivingExaminerJudgment: "Висновок екзаменатора з водіння",
      DrivingExaminerJudgmentTEST2ARMS: "Висновок екзаменатора з водіння",
      DrivingExaminerJudgmentTEST2DRIVE: "Висновок екзаменатора з водіння",
      DrivingExaminerJudgmentTEST2SAFE: "Висновок екзаменатора з водіння",
      DrivingExaminerJudgmentTEST2WORK: "Висновок екзаменатора з водіння",
      DrivingInstructorJudgment: "Висновок інструктора з водіння",
      DrivingInstructorJudgmentTEST2ARMS: "Висновок інструктора з водіння",
      DrivingInstructorJudgmentTEST2DRIVE: "Висновок інструктора з водіння",
      DrivingInstructorJudgmentTEST2SAFE: "Висновок інструктора з водіння",
      DrivingInstructorJudgmentTEST2WORK: "Висновок інструктора з водіння",
      DrivingTechniqueInstructorJudgment:
        "Висновок інструктора з техніки водіння",
      EmergencyVehicleDriverJudgment: "Висновок на керування спецтранспортом",
      EmergencyVehicleDriverJudgmentTEST2ARMS:
        "Висновок на керування спецтранспортом",
      EmergencyVehicleDriverJudgmentTEST2DRIVE:
        "Висновок на керування спецтранспортом",
      EmergencyVehicleDriverJudgmentTEST2SAFE:
        "Висновок на керування спецтранспортом",
      EmergencyVehicleDriverJudgmentTEST2WORK:
        "Висновок на керування спецтранспортом",
      ExaminationCard: "Картка обстеження",
      ExaminationCardTEST2ARMS: "Картка обстеження TEST2ARMS",
      ExaminationCardTEST2DRIVE: "Картка обстеження TEST2DRIVE",
      ExaminationCardTEST2SAFE: "Картка обстеження TEST2SAFE",
      ExaminationCardTEST2WORK: "Картка обстеження TEST2WORK",
      FirearmLicenseJudgment: "Висновок на право володіння зброєю",
      FirearmLicenseJudgmentTEST2ARMS: "Висновок на право володіння зброєю",
      FirearmLicenseJudgmentTEST2DRIVE: "Висновок на право володіння зброєю",
      FirearmLicenseJudgmentTEST2SAFE: "Висновок на право володіння зброєю",
      FirearmLicenseJudgmentTEST2WORK: "Висновок на право володіння зброєю",
      MilitaryExplosivesJudgment:
        "Висновок на поліцейську/військову зброю та матеріали",
      MilitaryExplosivesJudgmentTEST2ARMS:
        "Висновок на поліцейську/військову зброю та матеріали",
      MilitaryExplosivesJudgmentTEST2DRIVE:
        "Висновок на поліцейську/військову зброю та матеріали",
      MilitaryExplosivesJudgmentTEST2SAFE:
        "Висновок на поліцейську/військову зброю та матеріали",
      MilitaryExplosivesJudgmentTEST2WORK:
        "Висновок на поліцейську/військову зброю та матеріали",
      OccupationalMedicineJudgmentTEST2ARMS: "Висновок з медицини праці",
      OccupationalMedicineJudgmentTEST2DRIVE: "Висновок з медицини праці",
      OccupationalMedicineJudgmentTEST2SAFE: "Висновок з медицини праці",
      OccupationalMedicineJudgmentTEST2WORK: "Висновок з медицини праці",
      PhysicalProtectionJudgment: "Висновок на ліцензію охоронця",
      PhysicalProtectionJudgmentTEST2ARMS: "Висновок на ліцензію охоронця",
      PhysicalProtectionJudgmentTEST2DRIVE: "Висновок на ліцензію охоронця",
      PhysicalProtectionJudgmentTEST2SAFE:
        "Висновок - працівник фізичної охорони",
      PhysicalProtectionJudgmentTEST2WORK: "Висновок на ліцензію охоронця",
      ProfessionalDriverJudgment: "Висновок на посаду водія",
      ProfessionalDriverJudgmentTEST2ARMS: "Висновок на посаду водія",
      ProfessionalDriverJudgmentTEST2DRIVE: "Висновок на посаду водія",
      ProfessionalDriverJudgmentTEST2SAFE: "Висновок на посаду водія",
      ProfessionalDriverJudgmentTEST2WORK: "Висновок на посаду водія",
      PsychologicalConsultation: "Психологічна консультація",
      PsychologicalConsultationTEST2ARMS: "Психологічна консультація",
      PsychologicalConsultationTEST2DRIVE: "Психологічна консультація",
      PsychologicalConsultationTEST2SAFE: "Психологічна консультація",
      PsychologicalConsultationTEST2WORK: "Психологічна консультація",
      PsychologicalOpinion: "Психологічний висновок",
      PsychologicalOpinionTEST2ARMS: "Психологічний висновок",
      PsychologicalOpinionTEST2DRIVE: "Психологічний висновок",
      PsychologicalOpinionTEST2SAFE: "Психологічний висновок - детективи",
      PsychologicalOpinionTEST2WORK: "Психологічний висновок",
    },
    opinion: {
      breadcrumbs: "Психологічний висновок",
      breadcrumbsAppeal: "Апеляційний психологічний висновок",
      examineeData: "Дані обстежуваного",
      statement: "НА ПІДСТАВІ ПРОВЕДЕНОГО ПСИХОЛОГІЧНОГО ОБСТЕЖЕННЯ ЗАСВІДЧУЮ",
    },
    report: {
      details: {
        PESEL: "ІПН",
        assignDate: "Дата призначення обстеження",
        endDate: "Дата завершення обстеження",
        firstName: "Ім'я",
        idExamination: "ID обстеження",
        identificationNumber: "Ідентифікатор",
        lastName: "Прізвище",
        name: "Назва обстеження",
        status: "Статус обстеження",
      },
      header: {
        interval: "Виберіть довірчий інтервал",
        language: "Виберіть мову звіту",
        recipient: "Виберіть отримувача",
        reportDiagnostic: "Діагностичний звіт",
        reportDiagnosticCharts: "Діагностичний звіт з графіками",
        reportInterpretation: "Інтерпретаційний звіт",
        standard: "Виберіть стандарт",
      },
      statusExamination: {
        skip: "Деякі тести були пропущені або перервані",
      },
    },
    snackbar: {
      save: "Документ успішно збережено",
    },
  },
  Email: {
    bodybreak:
      '<div style="color: #000000; font-family: Arial;font-size:12pt;line-height: 1.5rem;">\n  <p>Шановні панове,<br/><br/>\n  Повідомляємо, що <strong>[дата, наприклад, 30 червня 2025 року]</strong> в період з <strong>[наприклад, 22:00 - 02:00]</strong> ми проведемо планове технічне обслуговування для оновлення нашої системи.<br/>Під час робіт доступ до системи Optimis може бути тимчасово обмежений або недоступний. Просимо планувати роботу з системою з урахуванням цього періоду обслуговування<br /><br />\n  \n  Приносимо вибачення за будь-які незручності та дякуємо за розуміння.<br /><br />У разі питань просимо зв\'язатися з нами<br/>email: <strong>alta@alta.pl</strong><br/>телефон:<strong>(+48) 515 131 941</strong><br /><br />\n  \n  Це повідомлення було згенеровано автоматично - будь ласка, не відповідайте на нього.\n  <br/><br>\n  З найкращими побажаннями,\n  Команда ALTA </p>\n  </div>',
    bodysys:
      '<div style="color: #000000; font-family: Arial;font-size:12pt;line-height: 1.5rem;">\n  <p>Шановні панове,<br/><br/>\n  Повідомляємо, що в святковий період з <strong>24 грудня 2025 року</strong> по <strong>1 січня 2026 року</strong> наша служба підтримки буде закрита.<br/>Система OPTIMIS залишиться повністю доступною та працюватиме без змін.<br /><br />\n  \n  У разі термінових питань просимо зв\'язатися з нами після святкового перерви<br/>email: <strong>alta@alta.pl</strong><br/>телефон:<strong>(+48) 515 131 941</strong><br /><br />\n  Дякуємо за розуміння та бажаємо спокійних та радісних свят!<br /><br />\n  \n  Це повідомлення було згенеровано автоматично - будь ласка, не відповідайте на нього.\n  <br/><br>\n  З найкращими побажаннями,\n  Команда ALTA </p>\n  </div>',
    bodyupdate:
      '<div style="color: #000000; font-family: Arial;font-size:12pt;line-height: 1.5rem;">\n  <p>Шановні панове,<br/><br/>\n  Ми раді повідомити, що ми завершили оновлення системи <strong>OPTIMIS</strong>, яке відбулося [30 червня 2025 року].<br />Внесені зміни спрямовані на покращення функціональності та зручності використання.<br/><br/>Нижче ми представляємо ключові нововведення:<br /><br />\n  <ol>\n  <li><strong>Новий користувацький інтерфейс</strong>: Оновлений зовнішній вигляд та більш інтуїтивна навігація.</li>\n  <li><strong>Покращення продуктивності</strong>: Скорочений час завантаження та швидша обробка даних.</li>\n  <li><strong>Нові функції</strong>: Додано [наприклад, можливість персоналізації налаштувань, інтеграцію з новими інструментами, звіти в реальному часі].</li>\n  <li><strong>Підвищена безпека</strong>: Впроваджено додаткові заходи захисту для захисту даних користувачів.</li>\n  </ol>\n  \n  Система повністю доступна, і всі функції працюють згідно з задумкою.<br/><br/>У разі питань або необхідності підтримки запрошуємо зв\'язатися з нашою командою<br/>email: <strong>alta@alta.pl</strong><br/>телефон:<strong>(+48) 515 131 941</strong><br /><br />\n  Дякуємо за довіру та запрошуємо ознайомитися з новими можливостями системи!<br /><br />\n  \n  Це повідомлення було згенеровано автоматично - будь ласка, не відповідайте на нього.\n  <br/><br>\n  З найкращими побажаннями,\n  Команда ALTA </p>\n  </div>',
    subjectbreak: "Технічне обслуговування",
    subjectsys: "Святкова перерва",
    subjectupdate: "Оновлення програмного забезпечення",
  },
  ExaminationAssignmentView: {
    header: "Призначити обстеження",
    labels: {
      chooseExaminationType: "Виберіть тип обстеження",
      chooseLawBase: "Виберіть правову підставу обстеження",
      description: "Опис",
      legalBase: "Правова підстава обстеження",
      methodologyTest2Arms:
        "TEST2ARMS - методика психологічного тестування, ліцензована діяльність",
      methodologyTest2Drive:
        "TEST2DRIVE - методика проведення обстежень водіїв в рамках транспортної психології",
      methodologyTest2Safe:
        "TEST2SAFE - методика психологічного тестування для працівників охорони та детективів",
      methodologyTest2Work:
        "TEST2WORK - методика психологічного тестування в медицині праці",
      methodologyTest2SafeTlt: "TEST2SAFE",
      methodologyTest2DriveTlt: "TEST2DRIVE",
      methodologyTest2ArmsTlt: "TEST2ARMS",
      methodologyTest2WorkTlt: "TEST2WORK",
      methodologyTest2SafeDesc:
        "методика психологічного тестування для працівників охорони та детективів",
      methodologyTest2DriveDesc:
        "методика проведення обстежень водіїв в рамках транспортної психології",
      methodologyTest2ArmsDesc:
        "методика психологічного тестування, ліцензована діяльність",
      methodologyTest2WorkDesc:
        "методика психологічного тестування в медицині праці",
      reason: "Мета обстеження",
      suggestedTestMethods: "ПРОПОНОВАНІ МЕТОДИКИ",
      freeCredits: "доступні кредити: ",
      lockedCredits: "кредити, заблоковані в призначених обстеженнях: ",
      selectedTestCredits: "кредити за обрані тести: ",
    },
    license: "Тест недоступний у придбаній ліцензії",
    testAlreadyInExamination: "Цей тест вже доступний в обстеженні",
    popup: {
      checkbox: "Запам'ятати вибір для всіх обстежуваних",
      content: "Ви впевнені, що хочете пропустити ці тести?",
      header: "Деякі тести, рекомендовані для обраної методики, були вимкнені.",
      headerCredits: "Увага",
      contentCredits:
        "Неможливо вибрати тест, тому що сума кредитів за обрані тести перевищує кількість доступних кредитів.",
    },
  },
  ExaminationList: {
    deletePopup: {
      confirmationText: "Так, я хочу видалити обстеження",
      contentText: "Після видалення обстеження його неможливо буде відновити",
      headerText: "Ви впевнені, що хочете видалити обстеження?",
    },
    noTestsPopup: {
      headerText: "Немає тестів для додавання",
      content:
        "До цього обстеження більше не можна додати тести. Усі тести, доступні у вашій ліцензії, уже призначені для цього обстеження.",
    },
    kebabMenu: {
      delete: "Видалити обстеження",
    },
    labels: {
      assign: "Призначено",
      assignDate: "Дата призначення",
      assignDateMobile: "Додано",
      contract: "Контракт",
      create: "Створено",
      createDate: "Дата створення",
      documentation: "Документація",
      end: "Завершено",
      endDate: "Дата завершення",
      identificator: "ID",
      interview: "Інтерв'ю",
      language: "Мова",
      nameArchiveExamination: "Назва батареї",
      nameExamination: "Назва обстеження",
      start: "Розпочато",
      startDate: "Дата початку",
      testCnt: "Тести",
      creditsCnt: "Кредити",
      extendExamMobile: "Додати тести",
      recalculateExamMobile: "Перерахувати",
      examTlt: "Обстеження містить:",
      methodologyNameTlt: "методики:",
      testNameTlt: "тести:",
    },
    toolTip: {
      contract: "Згенерувати контракт",
      delete: "Видалити",
      documentation: "Документація",
      interview: "Інтерв'ю",
      blocked: "обстеження заблоковано через брак кредитів",
      extendExam: "Додати тести до обстеження",
      extendExamHidden: "Функція прихована (параметр SHOW_EXTENDED_EXAM=0)",
      recalculateExam: "Пересчитать обследование",
      recalculateExamHidden:
        "Функція прихована (параметр SHOW_RECALCULATE_EXAM=0 або потрібні права адміністратора лабораторії)",
    },
    withoutLegalBasis: "Обстеження без правової підстави",
  },
  ExaminationView: {
    aimsKind: {
      aimKind_1: "Психологічний висновок - детективи",
      aimKind_10:
        "Висновок - ліцензована діяльність військового або поліцейського призначення",
      aimKind_11: "Висновок - ліцензована діяльність цивільного призначення",
      aimKind_12:
        "Апеляційний висновок - ліцензована діяльність цивільного призначення",
      aimKind_13: "Висновок - медицина праці",
      aimKind_14:
        "Висновок - медицина праці гірнича справа та гірничорятувальні роботи",
      aimKind_15: "Висновок - медицина праці ліцензія машиніста",
      aimKind_16:
        "Висновок - водій категорії C1, C1+E, C, C+E, D1, D1+E, D і D+E або керування трамваєм",
      aimKind_17:
        "Висновок - відновлення водійських прав категорії AM, A1, A2, A, B1, B, B+E і T",
      aimKind_18:
        "Висновок - відновлення водійських прав психологічні протипоказання",
      aimKind_19:
        "Висновок - продовження прав категорії C1, C1+E, C, C+E, D1, D1+E, D і D+E або керування трамваєм",
      aimKind_20: "Висновок - післяаварійне обстеження водія",
      aimKind_21:
        "Висновок - обстеження водія після вживання алкоголю або подібних речовин",
      aimKind_22: "Висновок - обстеження водія після перевищення 24 балів",
      aimKind_23: "Висновок - обстеження водія після щонайменше 2 порушень",
      aimKind_24: "Висновок - обстеження водія психологічні протипоказання",
      aimKind_25: "Висновок - водій спеціального транспорту",
      aimKind_26:
        "Висновок - післяаварійне обстеження водія (направлення старости)",
      aimKind_27: "Висновок - виконання обов'язків інструктора",
      aimKind_28: "Висновок - виконання обов'язків екзаменатора",
      aimKind_29:
        "Висновок - водій-учень або кандидат у середню школу категорії C або C+E",
      aimKind_3: "Висновок - працівник фізичної охорони",
      aimKind_30:
        "Висновок - водій-учень або кандидат на професійний курс категорії C або C+E",
      aimKind_31: "Висновок - професійний водій за направленням роботодавця",
      aimKind_32: "Висновок - самозайнятий професійний водій",
      aimKind_8: "Апеляційний висновок - працівник фізичної охорони",
      aimKind_9: "Висновок - дозвіл на зброю",
    },
    breadcrumbs: {
      archive: "Архівні обстеження",
    },
    common: {
      unavailableInLanguageOption: "Недоступно у вибраній мовній версії.",
    },
    details: {
      createDate: "Створення обстеження",
      endDate: "Завершення обстеження",
      identificator: "ID обстеження",
      language: "Мова",
      name: "Назва обстеження",
      startDate: "Дата початку обстеження",
      type: "Назва батареї",
    },
    header: "Документація",
    labels: {
      details: "Деталі",
      download: "Завантажити",
      edit: "Редагувати",
      generate: "Згенерувати",
      name: "Назва тесту",
      nameFile: "Ім'я файлу",
      print: "Друк",
      result: "Результат",
      type: "Тип документа",
    },
    protocols: {
      language: "Мова протоколів",
      testProtocol: "Протокол тесту",
      noProtocol: "Немає протоколів тестів для вибраного обстеження",
    },
    tabs: {
      documentation: "Документація",
      protocols: "Протоколи",
      reports: "Звіти",
    },
  },
  ExamineeList: {
    labels: {
      added: "Додано",
      allFinishExam: "Призначено / завершено",
      contract: "Контракт",
      examine: "Обстеження",
      examineLastDate: "Дата останнього обстеження",
      firstName: "Ім'я",
      folder: "Папка",
      lastName: "Прізвище",
      peselSlashIdentifier: "ПЕСЕЛ / Ідентифікатор",
      profile: "Переглянути профіль",
      profileShort: "Профіль",
    },
  },
  ExamineeManagment: {
    breadcrumbs: {
      add: "Додати суб'єкта",
      dashboard: "Панель користувача",
      directories: "Картотека суб'єктів",
      edit: "Редагувати суб'єкта",
      import: "Імпортувати досліджуваних",
    },
    header: {
      add: "Додати нового суб'єкта",
      edit: "Редагувати дані суб'єкта",
      editMobile: "Редагувати дані",
      import: "Імпортувати досліджуваних",
    },
    importExaminees: {
      collapse: "згорнути",
      errors: {
        fileReadFailed: "Помилка читання файлу.",
        invalidPesel: "Файл імпорту містить недійсні номери PESEL.",
        invalidPeselFound: "Файл імпорту містить недійсні номери PESEL.",
        readFileError: "Помилка читання вмісту файлу.",
      },
      expand: "розгорнути",
      fileDesc:
        "Для імпорту даних потрібен файл у форматі CSV. Переконайтеся, що ваш файл відповідає наступним критеріям:",
      fileDesc1: "1. Заголовок:",
      fileDesc10: "Прізвище.",
      fileDesc11: "pesel:",
      fileDesc12:
        "Номер PESEL. Залиште порожнім, якщо не хочете його вказувати.",
      fileDesc13: "стать:",
      fileDesc14: "Стать - введіть male (чоловіча) або female (жіноча).",
      fileDesc15: "день народження:",
      fileDesc16:
        "Дата народження у форматі рррр-мм-дд (наприклад, 1985-03-21).",
      fileDesc17: "Приклад вмісту файлу CSV:",
      downloadCsvExample: "Завантажити приклад CSV-файлу",
      fileDesc18:
        "ім'я,прізвище,pesel,стать,день народження,анонімний,електронна пошта,телефон",
      fileDesc19: "Іван,Ковальчук,85032112345,male,1985-03-21,0",
      fileDesc2:
        "Перший рядок файлу повинен містити точно такі назви стовпців:",
      fileDesc20: "Анна,Шевченко,,female,1992-07-10,0",
      fileDesc21: "Досліджуваний,Анонімний,,male,1995-12-25,1",
      fileDesc22: "Пояснення прикладу:",
      fileDesc23: "Перший рядок - це обов'язковий заголовок.",
      fileDesc24: "Другий рядок містить повні дані Івана Ковальчука.",
      fileDesc25:
        "Третій рядок містить дані Анни Шевченко, але поле pesel навмисно залишено порожнім, оскільки ми не вказуватимемо номер PESEL для цієї особи.",
      fileDesc26: "Четвертий рядок містить повні дані Петра Зеленського.",
      fileDesc27:
        "Будь ласка, підготуйте файл відповідно до вищенаведених інструкцій, щоб забезпечити успішний імпорт даних.",
      fileDesc28: "анонімний:",
      fileDesc29:
        "Анонімний досліджуваний. 1 - анонімний досліджуваний, не буде запитуватися згода на обробку персональних даних, не може мати PESEL. 0 - досліджуваний з персональними даними",
      fileDesc3: "ім'я, прізвище, pesel, стать, день народження, анонімний",
      fileDesc30: "електронна пошта:",
      fileDesc31:
        "Адреса електронної пошти. Залиште порожнім, якщо не хочете її вказувати.",
      fileDesc32: "телефон:",
      fileDesc33:
        "Номер телефону. Залиште порожнім, якщо не хочете його вказувати.",
      fileDesc4: "2. Дані:",
      fileDesc5:
        "Кожен наступний рядок повинен містити дані для однієї особи, відповідно до порядку стовпців у заголовку.",
      fileDesc6: "3. Форматування даних:",
      fileDesc7: "ім'я:",
      fileDesc8: "Ім'я.",
      fileDesc9: "прізвище:",
      filePattern: "Формат файлу імпорту даних",
      importFile: "завантажити файл CSV",
      noFileSelected: "-",
      saveSuccess: "Досліджуваних успішно імпортовано.",
      success: "Файл імпорту успішно завантажено.",
      tltFileSelected: "попередній перегляд файлу імпорту: ",
    },
  },
  ExamineeView: {
    anonymity: "Анонімний суб'єкт",
    drivingLicense: {
      a: "A",
      a1: "A1",
      a2: "A2",
      am: "AM",
      b: "B",
      b1: "B1",
      be: "B+E",
      c: "C",
      c1: "C1",
      c1e: "C1+E",
      ce: "C+E",
      d: "D",
      d1: "D1",
      d1e: "D1+E",
      de: "D+E",
      t: "T",
      tramwaj: "TRAMWAJ",
    },
    emptyState: {
      header: "Немає обстежень, призначених цьому суб'єкту",
      info: "Щоб переглянути список обстежень, призначте хоча б одне обстеження.",
    },
    kebabMenu: {
      delete: "Видалити суб'єкта",
      edit: "Редагувати дані суб'єкта",
    },
    tabs: {
      archive: "Архівні обстеження",
      data: "Дані суб'єкта",
      examination: "Обстеження",
    },
    translations: {
      basicIndustry: "базова професійна освіта",
      basicVocational: "професійно-технічна освіта",
      female: "жінка",
      higher: "вища освіта",
      id_card: "посвідчення особи",
      lowerSecondary: "базова середня освіта",
      male: "чоловік",
      passport: "паспорт",
      primary: "початкова освіта",
      secondary: "повна загальна середня освіта",
      secondaryIndustry: "середня професійна освіта",
    },
    userData: {
      address: "Адреса",
      birthDate: "Дата народження",
      defaultAnonFirstName: "Суб'єкт",
      defaultAnonLastName: "Анонімний",
      drivingLicense: "Категорія водійських прав",
      drivingLicenseIssuer: "Орган, що видав водійські права",
      education: "Освіта",
      email: "Адреса електронної пошти",
      examineName: "Прізвище, ім'я, по батькові",
      identificator: "Ідентифікатор",
      identityCard: "Документ, що посвідчує особу",
      pesel: "Особистий номер",
      phone: "Номер телефону",
      serialNumber: "Серія та номер",
      sex: "Стать",
    },
  },
  ExportResults: {
    exportActivities: "Експорт у файл XLS",
    header: "Експорт результатів обстежень",
    headerMobile: "Експорт результатів обстежень",
    popups: {
      delete: {
        confirmationHeader: "Ви впевнені, що хочете видалити файл експорту?",
        confirmationText:
          "Після видалення файлу експорту не буде можливості його відновити.",
        confirmationCheckboxLabel: "Так, я хочу видалити файл експорту",
      },
    },
  },
  StatsExport: {
    popups: {
      delete: {
        confirmationHeader: "Ви впевнені, що хочете видалити файл статистики?",
        confirmationText:
          "Після видалення файлу статистики не буде можливості його відновити.",
        confirmationCheckboxLabel: "Так, я хочу видалити файл статистики",
      },
    },
  },
  FormLabels: {
    currentPassword: "Поточний пароль",
    email: "Електронна пошта",
    newPassword: "Новий пароль",
    password: "Пароль",
    pin: "ПІН-код",
  },
  FormValidation: {
    Password: {
      camelCase: "велику літеру, малу літеру",
      length: "Мінімум %lenght% символів",
      number: "цифру",
      settings: "Повинен містити:",
      spacialChar: "спеціальний символ",
    },
    Pin: {
      length: "Повинен містити 4 цифри",
    },
    max: "Назва не може перевищувати 128 символів",
    required: "Це поле є обов'язковим",
  },
  FormValidationErrors: {
    email: "Введене значення не є адресою електронної пошти",
    required: "Це поле є обов'язковим",
    passwordMinLength:
      "Ваш пароль повинен містити не менше %{minLength} символів",
    passwordRequirements: "Ваш пароль не відповідає всім необхідним умовам",
    pinLength: "PIN-код повинен складатися рівно з 4 цифр",
    pinDigitsOnly: "PIN-код може містити лише цифри",
  },
  Format: {
    ExamineeViewDateFormat: "DD.MM.YYYY",
    FormDateFormat: "D MMMM YYYY",
    ViewDateTime: "DD.MM.YYYY HH:mm",
  },
  Forms: {
    adminFields: {
      activityDetails: "Деталі",
      activityName: "дія",
      address: "Вулиця та номер будинку",
      cin: "Реєстраційний номер",
      city: "Місто",
      clientId: "ID клієнта",
      dateExpire: "Термін дії облікового запису",
      dateFrom: "період з",
      dateLicExpire: "Термін дії ліцензії",
      dateTo: "період по",
      email: "Електронна пошта",
      examineesCnt: "Обстежувані",
      firstName: "Ім'я",
      isActive: "Статус облікового запису",
      isStaff: "Роль",
      isSuperuser: "Користувач з правами адміністратора",
      isAdmin: "Адміністратор",
      allowAllAccounts: "Доступ до всіх облікових записів",
      allowAllOwnAndCreated:
        "Доступ до власного облікового запису та створених",
      lastName: "Прізвище",
      licMethodologies: "Доступні методології",
      licTests: "Доступні тести",
      methodologyTlt: "Методологія",
      name: "Назва",
      no: "ні",
      password: "Пароль",
      pin: "ПІН-код",
      postalCode: "поштовий індекс",
      pwdCamelCase: "Великі та малі літери",
      pwdLength: "Довжина пароля",
      pwdNumbers: "Цифра",
      pwdSpecialChar: "Особливий характер",
      creditsLic: "Ліцензія на кредити",
      credits: "Кредити",
      remainingCredits: "Кредити, що залишилися для використання",
      allCredits: "Придбані кредити",
      lockedCredits: "Кредити, заблоковані в обстеженнях",
      status: "статус",
      testCogTlt: "когнітивні тести",
      testPersonTlt: "особистісні тести",
      testPsychMotorTlt: "психомоторні тести",
      theme: "Оформлення",
      tin: "ІПН",
      usersCnt: "Користувачі",
      yes: "так",
    },
    adminOptions: {
      admin: {
        admin: "адміністратор",
        baseuser: "реєстратор",
        user: "користувач",
      },
      status: {
        active: "активний",
        disabled: "неактивний",
      },
      theme: {
        defaultTheme: "стандартна",
        optimisTheme: "optimis",
      },
    },
    adminSnackbar: {
      email_unique_error:
        "Дана адреса електронної пошти вже існує в базі даних!",
      email_wrong_error: "Вказана адреса електронної пошти недійсна!",
      invalidDate: "Дата надсилання не може бути раніше поточної дати",
      parametersSaved: "Параметри успішно збережено",
      required: "Необхідно заповнити всі обов'язкові поля.",
    },
    anonymous: "Анонімне обстеження",
    emailSender: {
      dateSend: "дата надсилання",
      emailSentSuccessed:
        "Повідомлення збережено та буде надіслано в запланований час",
      emailType: "тип повідомлення",
      muiRTEtextPlaceHolder: "Зміст повідомлення",
      subject: "тема",
      userLang: "мова користувача",
      user: "користувач",
      admin: "адміністратор",
      staff: "реєстратор",
    },
    exportResults: {
      confidenceLevel: "довірчий інтервал",
      dateFrom: "дата з",
      dateTo: "дата до",
      examineeAge: "вік",
      examineeData: "дані обстежуваного",
      examineeEdu: "освіта",
      examineeName: "ім'я та прізвище",
      examineeFolder: "назва папки",
      examineeId: "ID/ідентифікатор",
      examineeLab: "назва клієнта",
      examineeSex: "стать",
      exportDeletedFileSucceeded: "Файл експорту було видалено.",
      exportSucceeded:
        "Запит на експорт прийнято. Ви отримаєте електронний лист про завершення (успіх або помилка).",
      filesRefresh: "оновити",
      filesToDownload: "Файли для завантаження:",
      folders: "папки",
      genres: "сфери діагностики",
      noFiles: "Немає файлів для відображення.",
      norm: "нормалізовані результати",
      normStd: "нормалізовані результати - довірчі інтервали",
      norms: "норма",
      protocol: "інтерв'ю",
      psychLabs: "клієнти",
      raw: "сирі результати",
      rawStd: "сирі результати - довірчі інтервали",
      resultsData: "результати",
      tests: "тести",
    },
    statsExport: {
      exportSucceeded:
        "Запит на експорт статистики прийнято. Ви отримаєте електронний лист про завершення (успіх або помилка).",
      deletedFileSucceeded: "Файл статистики видалено.",
      filesToDownload: "Файли статистики для завантаження:",
      noFiles: "Немає файлів статистики для відображення.",
      filesRefresh: "оновити",
      rangeRequired: "Виберіть діапазон дат (з і по).",
    },
    extraFields: "Додаткові дані",
    fields: {
      additionalInfo: "Додаткова інформація",
      address: "Вулиця та номер будинку",
      age: "Вік",
      appealAuthority: "Назва установи",
      appealDeadline: "Дата",
      birthDate: "Дата народження",
      city: "Місто",
      country: "Країна",
      date: "Дата",
      diffrentIdentificationNumber: "Інший ідентифікатор",
      directory: "Папка",
      documentDate: "Дата видачі",
      drivingLicense: "Категорія водійських прав",
      drivingLicenseIssuer: "Орган видачі водійських прав",
      education: "Освіта",
      email: "Адреса електронної пошти",
      examineeRegistryId: "Номер у реєстрі обстежуваних",
      identificationNumber: "Особистий номер",
      identityDocumentNumber: "Серія та номер",
      identityDocumentType: "Документ, що посвідчує особу",
      institutionName: "Назва установи",
      interval: "Виберіть довірчий інтервал",
      judgmentNumber: "Номер рішення",
      lang: "Мова",
      languageReport: "Виберіть мову звіту",
      legalBasis: "Правова підстава обстеження",
      months: "місяці",
      name: "Ім'я",
      nextExamination: "Дата наступного обстеження",
      phone: "Номер телефону",
      postalCode: "Поштовий індекс",
      recipient: "Виберіть отримувача",
      sex: "Стать",
      standard: "Виберіть стандарт",
      surname: "Прізвище",
      year: "Рік",
      years: "Років",
      testName: "Назва тесту",
      credits: "Ціна клієнта",
      creditsGlobal: "Ціна",
      value: "Значення",
      values: "Значення",
    },
    options: {
      activities: {
        ADMIN_CHANGE_LAB_ID: "Адміністратор увійшов в обліковий запис клієнта",
        ADMIN_LICENCE_ADDED: "Додано ліцензію для облікового запису клієнта",
        ADMIN_LICENCE_CHANGED: "Змінено ліцензію облікового запису клієнта",
        ADMIN_LICENCE_DELETED: "Видалено ліцензію облікового запису клієнта",
        ADMIN_LOGGED_IN: "Адміністратор увійшов у систему",
        ADMIN_LOGGED_OUT: "Адміністратор вийшов із системи",
        ADMIN_PSYCHOLOGICAL_LAB_ADDED: "Додано обліковий запис клієнта",
        ADMIN_PSYCHOLOGICAL_LAB_CHANGED:
          "Змінено дані облікового запису клієнта",
        ADMIN_PSYCHOLOGICAL_LAB_DELETED: "Видалено обліковий запис клієнта",
        ADMIN_USER_ADDED: "Додано користувача до облікового запису клієнта",
        ADMIN_USER_CHANGED:
          "Змінено дані користувача облікового запису клієнта",
        ADMIN_USER_DELETED: "Видалено користувача з облікового запису клієнта",
        ALL: "всі",
        ALL_ITEMS: "Всі дії",
        APP_REGISTRATION: "Реєстрація додатку",
        AUDIT_ERROR: "Помилка журналу активності",
        CONSOLE_PIN_VERIFICATION: "Перевірка ПІН-коду на консолі користувача",
        CONTRACT_DOWNLOADED: "Контракт завантажено",
        DIRECTORY_CREATED: "Папку створено",
        DIRECTORY_DELETED: "Папку видалено",
        DIRECTORY_NAME_CHANGED: "Назву папки змінено",
        EXAMINATION_ASSIGNED: "Обстеження призначено",
        EXAMINATION_DELETED: "Обстеження видалено",
        EXAMINATION_PROTOCOLS_ZIP_DOWNLOADED:
          "Протоколи обстеження ZIP завантажено",
        EXAMINATION_PROTOCOL_DOWNLOADED: "Протокол обстеження завантажено",
        EXAMINATION_REPORT_DOWNLOADED: "Документи звіту завантажено",
        EXAMINATION_STARTED: "Обстеження розпочато",
        EXAMINATION_TERMINATED: "Обстеження завершено",
        EXAMINEE_ADDED: "Суб'єкта додано",
        EXAMINEE_DATA_CHANGE: "Дані суб'єкта змінено",
        EXAMINEE_DELETED: "Дані суб'єкта видалено",
        EXAMINEE_MOVED_TO_DIFFERENT_DIRECTORY:
          "Дані суб'єкта переміщено до іншої папки",
        IMPORT_EXAMINEE: "Імпорт обстежуваних",
        INTERVIEW_CHANGED: "Інтерв'ю змінено",
        INTERVIEW_DOWNLOADED: "Інтерв'ю завантажено",
        PASSWORD_CHANGE: "Зміна пароля",
        PASSWORD_CHANGE_EXPIRED: "Зміна пароля після закінчення терміну дії",
        PASSWORD_CHANGE_REQUEST: "Запит на зміну пароля",
        PIN_CHANGE: "Зміна ПІН-коду",
        SAVE_AGREEMENTS: "Збереження згод на обстеження та обробку даних",
        TEST_RESULT_SUBMITTED: "Результати тесту надіслано",
        TEST_SKIPPED: "Тест пропущено на консолі",
        USER_LOGGED_IN: "Користувач увійшов у систему",
        USER_LOGGED_OUT: "Користувач вийшов із системи",
        ADMIN_PRICELIST_CHANGED: "Модифікація глобального прейскуранту",
        ADMIN_LAB_ANONYMIZED: "Анонімізація даних",
        EXPORT_RESULTS_GENERATED: "Експорт результатів згенеровано",
        EXPORT_FILE_DOWNLOADED: "Файл експорту результатів завантажено",
        EXPORT_FILE_DELETED: "Файл експорту результатів видалено",
        LAB_PARAMS_BULK_UPDATED: "Оновлення параметрів лабораторії",
        EXAMINATION_DOCUMENT_DOWNLOADED: "Документ обстеження завантажено",
        EXAMINATION_DOCUMENT_CHANGED: "Документ обстеження змінено",
        EXAMINATION_EXTENDED: "Обстеження розширено новими тестами",
        IMPORT_EXAMINEE_AND_ASSIGNED_EXAMINATION:
          "Імпорт обстежуваних та призначення обстежень",
        TEST_TYPE_CREDITS_UPDATED:
          "Модифікація прейскуранту тестів для клієнта",
        LICENSE_CREDITS_DEDUCTED:
          "Списання кредитів при збереженні результатів тесту",
      },
      activitiesStatus: {
        ok: "ок",
        server_error: "помилка сервера",
        user_error: "помилка користувача",
      },
      bool: {
        false: "Ні",
        true: "Так",
      },
      country: {
        afghanistan: "Afghanistan",
        albania: "Albania",
        algeria: "Algeria",
        americanSamoa: "American Samoa",
        andorra: "Andorra",
        angola: "Angola",
        anguilla: "Anguilla",
        antarctica: "Antarctica",
        antiguaAndBarbuda: "Antigua and Barbuda",
        argentina: "Argentina",
        armenia: "Armenia",
        aruba: "Aruba",
        australia: "Australia",
        austria: "Austria",
        azerbaijan: "Azerbaijan",
        bahamas: "Bahamas",
        bahrain: "Bahrain",
        bangladesh: "Bangladesh",
        barbados: "Barbados",
        belarus: "Belarus",
        belgium: "Belgium",
        belize: "Belize",
        benin: "Benin",
        bermuda: "Bermuda",
        bhutan: "Bhutan",
        bolivia: "Bolivia",
        bonaireSintEustatiusAndSaba: "Bonaire, Sint Eustatius and Saba",
        bosniaAndHerzegovina: "Bosnia and Herzegovina",
        botswana: "Botswana",
        bouvetIsland: "Bouvet Island",
        brazil: "Brazil",
        britishIndianOceanTerritory: "British Indian Ocean Territory",
        bruneiDarussalam: "Brunei Darussalam",
        bulgaria: "Bulgaria",
        burkinaFaso: "Burkina Faso",
        burundi: "Burundi",
        cambodia: "Cambodia",
        cameroon: "Cameroon",
        canada: "Canada",
        capeVerde: "Cape Verde",
        caymanIslands: "Cayman Islands",
        centralAfricanRepublic: "Central African Republic",
        ceuta: "Ceuta",
        chad: "Chad",
        chile: "Chile",
        china: "China",
        christmasIsland: "Christmas Island",
        cocosIslands: "Cocos (Keeling) Islands",
        colombia: "Colombia",
        comoros: "Comoros",
        congo: "Congo (Rep.)",
        cookIslands: "Cook Islands",
        costaRica: "Costa Rica",
        coteDivoire: "Cote D’Ivoire",
        croatia: "Croatia",
        cuba: "Cuba",
        curacao: "Curaçao",
        cyprus: "Cyprus",
        czechRepublic: "Czechia",
        democraticRepublicOfTheCongo: "Congo (Dem. Rep.)",
        denmark: "Denmark",
        djibouti: "Djibouti",
        dominica: "Dominica",
        dominicanRepublic: "Dominican Republic",
        ecuador: "Ecuador",
        egypt: "Egypt",
        elSalvador: "El Salvador",
        equatorialGuinea: "Equatorial Guinea",
        eritrea: "Eritrea",
        estonia: "Estonia",
        ethiopia: "Ethiopia",
        falklandIslands: "Falkland Islands (Malvinas)",
        faroeIslands: "Faroe Islands",
        fiji: "Fiji",
        finland: "Finland",
        france: "France",
        frenchPolynesia: "French Polynesia",
        frenchSouthernTerritories: "French Southern Territories",
        gabon: "Gabon",
        gambia: "Gambia",
        georgia: "Georgia",
        germany: "Germany",
        ghana: "Ghana",
        gibraltar: "Gibraltar",
        greece: "Greece",
        greenland: "Greenland",
        grenada: "Grenada",
        guam: "Guam",
        guatemala: "Guatemala",
        guinea: "Guinea",
        guineaBssau: "Guinea-Bissau",
        guyana: "Guyana",
        haiti: "Haiti",
        heardAndMcdonaldIslands: "Heard and McDonald Islands",
        honduras: "Honduras",
        hongKong: "Hong Kong",
        hungary: "Hungary",
        iceland: "Iceland",
        india: "India",
        indonesia: "Indonesia",
        iran: "Iran, Islamic Republic of",
        iraq: "Iraq",
        ireland: "Ireland",
        israel: "Israel",
        italy: "Italy",
        jamaica: "Jamaica",
        japan: "Japan",
        jordan: "Jordan",
        kazakhstan: "Kazakhstan",
        kenya: "Kenya",
        kiribati: "Kiribati",
        koreaNorth: "Korea, Democratic People’s Republic of",
        kosovo: "Kosovo",
        kuwait: "Kuwait",
        kyrgyztan: "Kyrgyztan",
        lao: "Lao, People’s Democratic Republic of",
        latvia: "Latvia",
        lebanon: "Lebanon",
        lesotho: "Lesotho",
        liberia: "Liberia",
        libyan: "Libyan Arab Jamahiriya",
        liechtenstein: "Liechtenstein",
        lithuania: "Lithuania",
        luxembourg: "Luxembourg",
        macao: "Macao",
        madagascar: "Madagascar",
        malawi: "Malawi",
        malaysia: "Malaysia",
        maldives: "Maldives",
        mali: "Mali",
        malta: "Malta",
        marshallIslands: "Marshall Islands",
        mauritania: "Mauritania",
        mauritius: "Mauritius",
        mayotte: "Mayotte",
        melilla: "Melilla",
        mexico: "Mexico",
        micronesia: "Micronesia, Federal States of",
        moldova: "Moldova, Republic of",
        mongolia: "Mongolia",
        montenegro: "Montenegro",
        montserrat: "Montserrat",
        morocco: "Morocco",
        mozambique: "Mozambique",
        myanmar: "Myanmar",
        namibia: "Namibia",
        nauru: "Nauru",
        nepal: "Nepal",
        netherlands: "Netherlands",
        newCaledonia: "New Caledonia",
        newZealand: "New Zealand",
        nicaragua: "Nicaragua",
        niger: "Niger",
        nigeria: "Nigeria",
        niue: "Niue",
        norfolk: "Norfolk Island",
        northernMacedonia: "North Macedonia",
        northernMarianaIslands: "Northern Mariana Islands",
        norway: "Norway",
        oman: "Oman",
        pakistan: "Pakistan",
        palau: "Palau",
        palestinian: "Palestinian Territory, Occupied",
        panama: "Panama",
        papuaNewGuinea: "Papua New Guinea",
        paraguay: "Paraguay",
        peru: "Peru",
        philippines: "Philippines",
        pitcairn: "Pitcairn",
        poland: "Poland",
        portugal: "Portugal",
        qatar: "Qatar",
        romania: "Romania",
        russia: "Russian Federation",
        rwanda: "Rwanda",
        saintBarthelemy: "Saint Barthelemy",
        samoa: "Samoa",
        sanMarino: "San Marino",
        saoTomeAndPrincipe: "Sao Tome and Principe",
        saudiArabia: "Saudi Arabia",
        senegal: "Senegal",
        serbia: "Serbia",
        seychelles: "Seychelles",
        sierraLeone: "Sierra Leone",
        singapore: "Singapore",
        sintMaartenDutch: "Sint Maarten (Dutch part)",
        slovakia: "Slovakia",
        slovenia: "Slovenia",
        solomonIslands: "Solomon Islands",
        somalia: "Somalia",
        southAfrica: "South Africa",
        southGeorgiaAndSouthSandwichIslands:
          "South Georgia and South Sandwich Islands",
        southKorea: "Korea, Republic of",
        southSudan: "South Sudan",
        spain: "Spain",
        sriLanka: "Sri Lanka",
        stHelena: "St.Helena",
        stKittsandAndNevis: "St.Kittsand and Nevis",
        stLucia: "St.Lucia",
        stPierreAndMiquelon: "St Pierre and Miquelon",
        stVincentAndTheGrenadines: "St Vincent and the Grenadines",
        sudan: "Sudan",
        suriname: "Suriname",
        swaziland: "Swaziland",
        sweden: "Sweden",
        switzerland: "Switzerland",
        syrian: "Syrian Arab Republic",
        taiwan: "Taiwan, Provice of China",
        tajikistan: "Tajikistan",
        tanzania: "Tanzania, United Republic of.",
        thailand: "Thailand",
        timorLeste: "Timor Leste",
        togo: "Togo",
        tokelau: "Tokelau",
        tonga: "Tonga",
        trinidadAndTobago: "Trinidad and Tobago",
        tunisia: "Tunisia",
        turkey: "Turkey",
        turkmenistan: "Turkmenistan",
        turksAndCaicosIslands: "Turks and Caicos Islands",
        tuvalu: "Tuvalu",
        uganda: "Uganda",
        ukraine: "Ukraine",
        unitedArabEmirates: "United Arab Emirates",
        unitedKingdom: "United Kingdom",
        unitedKingdomNorthernIreland: "United Kingdom (Northern Ireland)",
        unitedStatesOfAmerica: "United States of America",
        uruguay: "Uruguay",
        usMinorOutlyingIslands: "U.S. Minor Outlying Islands",
        uzbekistan: "Uzbekistan",
        vanuatu: "Vanuatu",
        vatican: "Vatican City State",
        venezuela: "Venezuela",
        vietnam: "Vietnam",
        virginIslandsBritish: "Virgin Islands (British)",
        virginIslandsUSA: "Virgin Islands (USA)",
        wallisAndFutuna: "Wallis and Futuna Islands",
        westernSahara: "Western Sahara",
        yemen: "Yemen",
        zambia: "Zambia",
        zimbabwe: "Zimbabwe",
      },
      education: {
        basicIndustry: "Базова професійна",
        basicVocational: "Професійно-технічна",
        higher: "Вища",
        lowerSecondary: "Базова середня",
        primary: "Початкова",
        secondary: "Повна загальна середня",
        secondaryIndustry: "Середня професійна",
      },
      emailType: {
        break: "технічне обслуговування",
        system: "інформація",
        update: "оновлення",
      },
      exportResultConfidenceLevel: {
        item_85: "0.85",
        item_9: "0.9",
        item_95: "0.95",
        item_99: "0.99",
      },
      genres: {
        cognitive: "когнітивні та інтелектуальні процеси",
        personality: "особистість",
        psychomotor: "психомоторика",
      },
      identityDocument: {
        idCard: "Посвідчення особи",
        passport: "Паспорт",
      },
      lang: {
        english: "Англійська",
        espaniol: "Іспанська",
        mexico: "Мексиканська іспанська",
        polish: "Польська",
        russian: "Російська",
        ukrain: "Українська",
      },
      languagesDocumentation: {
        en: "англійська",
        pl: "польська",
      },
      norms: {
        norm_1: "OPT_1.0.PL",
        norm_2: "OPT_1.0.UA",
        norm_3: "OPT_1.0.RU",
      },
      recipient: {
        examinee: "Обстежуваний",
        psychologist: "Психолог",
        specialist: "Спеціаліст",
      },
      sex: {
        female: "Жінка",
        male: "Чоловік",
      },
    },
    passwordFields: "Налаштування пароля",
    pwdFields: "Політика паролів",
    requiredFields: "Обов'язкові дані",
    selectAll: "вибрати все",
    snackbar: {
      peselLength: "Особистий номер повинен складатися з 11 цифр",
      peselNumber: "Особистий номер повинен містити лише цифри",
      required: "Необхідно заповнити всі обов'язкові поля.",
    },
  },
  HelpDocs: {
    contractFileName1: "/help-documents/pl-pl/kontrakt_psychologiczny_2024.pdf",
    contractFileName2:
      "/help-documents/pl-pl/kontrakt_psychologiczny_ru_2024.pdf",
    contractFileName3:
      "/help-documents/pl-pl/kontrakt_psychologiczny_ua_2024.pdf",
    contractFileName4:
      "/help-documents/pl-pl/polityka_ochrony_danych_osobowych_klauzula_informacyjna_2024.pdf",
    contractName1: "Психологічний контракт 2024",
    contractName2: "Психологічний контракт RU 2024",
    contractName3: "Психологічний контракт UA 2024",
    contractName4:
      "Політика захисту персональних даних - Інформаційна клаузула 2024",
    contractTitle: "Контракти",
    handbookFileName1:
      "/help-documents/pl-pl/charakterystyka_obszarow_diagnozy.pdf",
    handbookFileName2: "/help-documents/pl-pl/testy_psychomotoryczne.pdf",
    handbookFileName3: "/help-documents/pl-pl/testy_poznawcze.pdf",
    handbookFileName4: "/help-documents/pl-pl/testy_osobowosci.pdf",
    handbookFileName5: "/help-documents/pl-pl/katalog_testow_03_2024.pdf",
    handbookName1: "Характеристика областей діагностики",
    handbookName2: "Тести психомоторні",
    handbookName3: "Тести пізнавальні",
    handbookName4: "Тести особистості",
    handbookName5: "Каталог тестів 03-2024",
    handbookTitle: "Посібник і каталог тестів",
    modulesFileName1: "/help-documents/pl-pl/sytuacja_zdrowotna.pdf",
    modulesFileName10:
      "/help-documents/pl-pl/psychologia_transportu_kierowanie pojazdami_mtd_IV.pdf",
    modulesFileName2: "/help-documents/pl-pl/sytuacja_spoleczna_i_rodzinna.pdf",
    modulesFileName3: "/help-documents/pl-pl/obserwacja.pdf",
    modulesFileName4: "/help-documents/pl-pl/detektywi_ochrona_bron_mtd_I.pdf",
    modulesFileName5: "/help-documents/pl-pl/koncesja_mtd_II.pdf",
    modulesFileName6: "/help-documents/pl-pl/medycyna_pracy_mtd_III.pdf",
    modulesFileName7: "/help-documents/pl-pl/kierowcy_sluzbowi_mtd_III.pdf",
    modulesFileName8: "/help-documents/pl-pl/praca_wysokosc_mtd_III.pdf",
    modulesFileName9: "/help-documents/pl-pl/wozki_widlowe_mtd_III.pdf",
    modulesName1: "Стан здоров'я",
    modulesName10:
      "Психологія транспорту керування транспортними засобами MTD IV",
    modulesName2: "Соціальна та сімейна ситуація",
    modulesName3: "Спостереження",
    modulesName4: "Детективи охорона зброя MTD I",
    modulesName5: "Концесія MTD II",
    modulesName6: "Медицина праці MTD III",
    modulesName7: "Водії службові MTD III",
    modulesName8: "Робота на висоті MTD III",
    modulesName9: "Візки штабелювальні MTD III",
    modulesTitle: "Модулі інтерв'ю",
    policyName1:
      "Політика захисту персональних даних - Інформаційна клаузула 2024",
    policyTitle1: "Політика захисту персональних даних",
  },
  Helpdesk: {
    contact: "Контакти",
    text1:
      "Звіти про помилки або неправильну роботу системи слід надсилати електронною поштою на адресу: ",
    text2: "optimis@alta.pl",
    text3: "Технічна підтримка доступна в робочі дні",
    text4: "в годинах з 8:00 до 16:00",
    documents: {
      header: "Довідкові документи",
      labels: {
        download: "Завантажити",
        name: "Назва документа",
      },
    },
    header: "Допомога",
    help: "Віддалена підтримка",
    mobile: "моб.",
    phoneNo: "тел.",
    subheader: "Служба підтримки",
    phoneNo1: "(+48) 32 249 50 40",
    phoneNo2: "(+48) 515 131 941",
    phoneNo3: "",
    emailValue: "",
  },
  Interview: {
    header: "Інтерв'ю",
    hours: "Годин",
    inputAdditionalInformation: "Введіть додаткову інформацію",
    inputHoursOfWork: "Введіть кількість робочих годин за останню добу",
    months: "Місяців",
    questions: {
      methodologies: {
        currentPsychophysicalState: {
          headers: {
            criticalEvents: "Критичні події",
            currentState: "Поточний психофізичний стан",
          },
          questionExtendedTexts: {
            commonText: "Опишіть обставини цієї події/ситуації",
          },
          questionTexts: {
            question1:
              "Чи вживав обстежуваний алкоголь протягом останніх 48 годин?",
            question10: "Звернення за допомогою до:",
            question10a: "a. психолога",
            question10b: "b. психіатра",
            question10c: "c. невролога",
            question11: "Довідка про інвалідність",
            question12: "Проблеми, пов'язані з вживанням алкоголю",
            question13: "Перебування у витверезнику",
            question14:
              "Вживання одурманюючих/психоактивних речовин/наркотиків",
            question15:
              "Пропозиції лікаря або близької людини звернутися за лікуванням через нервозність, розсіяність або проблеми з пам'яттю чи орієнтацією",
            question2:
              "Чи працював обстежуваний професійно протягом останньої або передостанньої ночі?",
            question3: "Кількість робочих годин за останню добу",
            question4: "Травма голови, що потребувала медичної допомоги",
            question5: "Втрата свідомості",
            question6: "Перебування в лікарні",
            question7:
              "Чи було колись або є зараз лікування/чи був колись діагноз наступних захворювань:",
            question7a:
              "a. захворювання травної системи (виразка шлунка або дванадцятипалої кишки, порушення функції кишечника тощо)",
            question7b:
              "b. захворювання серця та системи кровообігу (ішемічна хвороба, підвищений артеріальний тиск)",
            question7c:
              "c. порушення слуху або зору (за винятком носіння коригуючих окулярів)",
            question7d: "d. діабет",
            question7e: "e. епілепсія",
            question7f:
              "f. психічні захворювання (депресія, невроз, психіатричне лікування (уточнити про психіатричне лікування близького члена сім'ї)",
            question8:
              "Регулярний прийом ліків (уточнити, чи знає про побічні ефекти та запитати про інші ліки, що впливають на психічні функції)",
            question9: "Проблеми зі сном",
          },
        },
        detectivesSecurityGuardsAndWeaponPermits: {
          questionAnswers: {
            question1a: "для професійних цілей (детектив, охоронець)",
            question1b: "для мисливських цілей",
            question1c: "для спортивних цілей",
            question1d: "для особистого користування",
            question1e: "для музейних, пам'ятних, наукових цілей",
            question1f: "інше",
          },
          questionTexts: {
            question1: "Основні цілі використання зброї:",
            question1g: "Які?",
            question2:
              "Чи мало місце коли-небудь застосування зброї або інших засобів прямого примусу?",
            question3: "Як часто застосовувалась зброя за останні 5 років?",
          },
        },
        drivingVehicles: {
          headers: {
            drivingCharacteristics: "Характеристика маршрутів",
          },
          questionAnswers: {
            question13a: "як винуватець/співвинуватець",
            question13b: "як потерпілий",
            question13c: "не застосовується",
            question14a: "як винуватець/співвинуватець",
            question14b: "як потерпілий",
            question14c: "не застосовується",
            question15a: "перевезення небезпечних матеріалів",
            question15b: "перевезення пасажирів",
            question15c: "інструктор з водіння",
            question15d: "екзаменатор з водіння",
            question15e: "відсутні",
            question3a: "менше 3 000 км на рік",
            question3b: "між 3 000 – 15 000 км на рік",
            question3c: "між 15 000 - 70 000 км на рік",
            question3d: "більше 70 000 км на рік",
            question3e: "важко сказати",
            question4a: "менше 5 годин на тиждень",
            question4b: "між 5 - 15 годин на тиждень",
            question4c: "між 15 - 40 годин на тиждень",
            question4d: "більше 40 годин на тиждень",
            question4e: "важко сказати",
            question5a: "їжджу переважно на коротких маршрутах",
            question5b: "їжджу переважно на довгих маршрутах",
            question5c: "їжджу як на довгих, так і на коротких маршрутах",
            question6a: "їжджу зазвичай постійними маршрутами",
            question6b: "їжджу найчастіше різними маршрутами",
            question7a: "їжджу найчастіше вночі",
            question7b: "їжджу зазвичай вдень",
            question7c: "їжджу як вдень, так і вночі",
            question8a: "їжджу в основному самостійно без змінника",
            question8b: "їжджу найчастіше зі змінником",
            question9a: "їжджу в основному по місту",
            question9b: "їжджу в основному за містом",
          },
          questionTexts: {
            question1: "Загальний стаж водіння",
            question10: "Призупинення або позбавлення водійських прав",
            question11: "Висновок про нездатність до водіння",
            question12: "Покарання за порушення ПДР або дорожній злочин",
            question13: "Участь як водія в автомобільній аварії",
            question14: "Участь як водія в дорожній пригоді",
            question15: "Додаткові кваліфікації та ліцензії",
            question2: "Стаж роботи водієм",
            question3: "Річний пробіг",
            question4: "Кількість годин за кермом",
            question5: "Довжина маршрутів",
            question6: "Різноманітність маршрутів",
            question7: "Час доби",
            question8: "Змінний водій",
            question9: "Територія",
          },
        },
        licensedActivity: {
          questionTexts: {
            question1:
              "Загальний стаж роботи в установі, що займається ліцензованою діяльністю",
            question2: "Посада/виконувані обов'язки",
            question3:
              "Стаж роботи на поточній посаді в установі, що займається ліцензованою діяльністю",
            question4a: "Участь у пригоді на робочому місці",
            question4b:
              "Якими були причини, наслідки пригоди - чи була завдана шкода майну, здоров'ю?",
          },
        },
        observation: {
          questionAnswers: {
            question1a:
              "Встановлює дуже добрий контакт із співрозмовником; підтримує зоровий контакт; поводиться впевнено та природно, не дозволяє вивести себе з рівноваги чи виявити нетерпіння, поводиться спонтанно та природно.",
            question1b:
              "Встановлює контакт із співрозмовником; підтримує зоровий контакт; поводиться природно, хоча помітні ознаки певного хвилювання.",
            question1c:
              "Поводиться відсторонено, уникає зорового контакту; поводиться неприродно, малі подразники викликають втрату рівноваги, видно явні ознаки нервозності та нетерпіння.",
            question2a:
              "Формулює висловлювання, використовуючи правильну мову, будує чіткі, зрозумілі речення, підтримує логічну структуру мовлення, використовує багатий словниковий запас.",
            question2b:
              "Формулює висловлювання правильно, загалом підтримує їх логічну структуру; словниковий запас середній, але правильний.",
            question2c:
              "Формулює короткі, формальні висловлювання, часто незв'язні або незрозумілі; використовує неправильні фрази та формулювання; речення дуже прості, словниковий запас дуже бідний, трапляються граматичні помилки.",
            question3a:
              "Спостерігається дуже веселий, оптимістичний настрій; задоволеність собою та своєю життєвою ситуацією.",
            question3b:
              "Спостерігається помірний настрій, досить позитивне ставлення та загалом оптимістичний погляд у майбутнє.",
            question3c:
              "Спостерігаються непропорційно сильні емоційні реакції, явна схильність до песимістичного сприйняття світу; прояв незадоволення.",
            question4a:
              "Під час обстеження адекватно контролює свою поведінку та емоції, адекватно пристосовується до виникаючих обставин.",
            question4b:
              "Під час обстеження загалом контролює свою поведінку та емоції; найчастіше адекватно реагує на виникаючі обставини.",
            question4c:
              "Під час обстеження спостерігаються труднощі з контролем поведінки та емоцій; з'являються неадекватна поведінка або емоції.",
          },
          questionTexts: {
            question1: "Контакт із співрозмовником",
            question2: "Мова та риторика",
            question3: "Настрій та ставлення",
            question4: "Самовладання та контроль поведінки й емоцій",
          },
        },
        occupationalMedicine: {
          headers: {
            companyCarDrivers: "Водії службових автомобілів",
            forkliftOperators: "Оператори навантажувачів",
            minersAndMinerLifeguards: "Шахтарі та гірничорятувальники",
            trainDriver: "Машиністи",
            workCourseInformation: "Історія професійної кар'єри",
            workInformation: "Інформація про професійну діяльність",
            workingAtHeights: "Робота на висоті",
          },
          questionAnswers: {
            question13a: "менше 3 000 км на рік",
            question13b: "між 3 000 – 15 000 км на рік",
            question13c: "між 15 000 - 70 000 км на рік",
            question13d: "більше 70 000 км на рік",
            question13e: "важко сказати",
            question14a: "менше 5 годин на тиждень",
            question14b: "між 5 - 15 годин на тиждень",
            question14c: "між 15 - 40 годин на тиждень",
            question14d: "більше 40 годин на тиждень",
            question14e: "важко сказати",
            question18a: "як винуватець/співвинуватець",
            question18b: "як потерпілий",
            question18c: "не застосовується",
            question19a: "як винуватець/співвинуватець",
            question19b: "як потерпілий",
            question19c: "не застосовується",
            question5a: "Монотонна робота",
            question5b: "Постійний великий потік інформації",
            question5c: "Високий рівень шуму",
            question5d:
              "Робота з високим психологічним навантаженням (відповідальність та прийняття рішень)",
            question5e: "Іонізуюче випромінювання",
            question5f: "Хімічні фактори",
            question5g: "Інші",
          },
          questionTexts: {
            question1: "Здобута професія",
            question10: "Обстежуваний потрапив у виробничу аварію",
            question10a: "Коли? Якими були наслідки для здоров'я?",
            question11: "Встановлено інвалідність",
            question11a: "З якої причини? З якого часу? До якого часу?",
            question12: "Загальний стаж водіння",
            question13: "Річний пробіг",
            question14: "Кількість годин за кермом",
            question15: "Висновок про нездатність до водіння",
            question16: "Призупинення або позбавлення водійських прав",
            question17: "Покарання за порушення ПДР або дорожній злочин",
            question18: "Участь як водія в автомобільній аварії",
            question19: "Участь як водія в дорожній пригоді",
            question2: "Поточна професія",
            question20: "Наявність допуску до роботи на висоті",
            question21:
              "Виконання робіт на висоті (якщо так, уточнити, скільки метрів над землею)",
            question22:
              "Суб'єктивне відчуття страху під час перебування на висоті",
            question23: "Нещасний випадок під час роботи на висоті",
            question23a: "Чи була завдана шкода майну або здоров'ю?",
            question24: "Наявність допуску до роботи оператором навантажувача",
            question25:
              "Виконання робіт, пов'язаних з обслуговуванням та керуванням навантажувачем",
            question26:
              "Нещасний випадок під час обслуговування або керування навантажувачем",
            question26a: "Чи була завдана шкода майну або здоров'ю?",
            question3: "Місце роботи / навчання",
            question4: "Посада / виконувані обов'язки",
            question5: "Постійні шкідливі/обтяжливі фактори на робочому місці",
            question5f: "Які?",
            question5g: "Які?",
            question6: "Загальний стаж роботи",
            question7: "Стаж роботи на поточній посаді",
            question8: "Діагностовано професійне захворювання",
            question8a: "Коли? З якої причини?",
            question9: "Призначено пенсійну допомогу",
            question9a: "З якої причини? З якого часу? До якого часу?",
          },
        },
        socialAndFamilySituation: {
          questionTexts: {
            question1:
              "Серйозний конфлікт або проблема, пов'язана з роботою (наприклад, нещасний випадок на роботі, догана, трудовий суд, дисциплінарне звільнення, мобінг)",
            question2:
              "Проблеми в період навчання (наприклад, повторення класу, виключення зі школи, призупинення прав учня)",
            question3:
              "Серйозний сімейний конфлікт або проблеми в особистих ситуаціях (наприклад, судові справи, участь у бійках, можна уточнити про сімейний стан, дітей)",
            question4:
              "Ситуація прямої загрози життю (наприклад, пожежа, повінь та інші катастрофи)",
            question5:
              "Досвід фізичного насильства щодо себе (наприклад, напад, крадіжка, побиття)",
            question6:
              "Участь у громадських організаціях (наприклад, волонтерство)",
            question7: "Судимість (наприклад, отримання штрафів, вирок суду)",
          },
        },
      },
      questionAnswers: {
        no: "ні",
        yes: "так",
      },
      questionTexts: {
        describeTheCircumStancesOfUsage: "Опишіть обставини використання",
        forHowLong: "До якого часу?",
        sinceWhen: "З якого часу?",
        whatAreTheConsequences: "Які були наслідки для здоров'я?",
        when: "Коли?",
        why: "З якої причини?",
      },
    },
    tabs: {
      currentPsychophysicalState: "Стан здоров'я",
      drivingVehicles: "Керування транспортними засобами",
      licensedActivities: "Ліцензована діяльність",
      observation: "Спостереження",
      occupationalMedicine: "Професійна медицина",
      securityAndDetectives: "Охоронні та детективні послуги",
      socialAndFamilySituation: "Соціальна та сімейна ситуація",
    },
    years: "Років",
  },
  Language: {
    pl: "Польська",
    ru: "Російська",
    uk: "Українська",
  },
  Login: {
    Access_denied: "Доступ заборонено",
    Captcha_error:
      "Помилка при заповненні captcha. Будь ласка, спробуйте знову.",
    Instance_configured_incorrectly:
      "Помилка конфігурації системи. Повідомте про проблему в технічну підтримку.",
    Laboratory_is_inactive_or_deleted: "Неактивний обліковий запис клієнта",
    Laboratory_account_has_expired:
      "Вхід неможливий — термін дії акаунта закінчився.",
    No_recaptcha_token_provided:
      "Помилка recaptcha. Повідомте про проблему в технічну підтримку.",
    User_account_has_been_deleted: "Учетная запись пользователя была удалена",
    User_account_is_not_active: "Обліковий запис користувача було видалено",
    Validation_failed: "Невірна електронна пошта або пароль.",
    adminHeader: "ПАНЕЛЬ АДМІНІСТРАТОРА",
    error: "Невірна електронна пошта або пароль.",
    header: "ВХІД",
    reset: "Скинути пароль",
    warning: "Увімкнено CAPS LOCK",
  },
  Onboarding: {
    errorText:
      "Під час встановлення пароля сталася помилка, будь ласка, спробуйте пізніше.",
    setNewPasswordInfo:
      "Введіть пароль, який ви будете використовувати для входу в систему.",
    setPasswordFormLabel: "Встановити пароль",
    setPinFormLabel: "Встановіть свій ПІН-код",
    setPinInfo:
      "Введіть ПІН-код, який ви будете використовувати для входу в консоль психолога.",
    success:
      "Ваші пароль та ПІН-код збережено. Тепер ви можете вперше увійти в додаток, використовуючи свою електронну адресу та пароль.",
    successTitle: "Пароль та ПІН-код встановлено",
  },
  Pagination: {
    outOf: "з",
  },
  PasswordExpired: {
    form: {
      header: "Встановити новий пароль",
      text: "Введіть пароль, який ви будете використовувати для входу в систему.",
    },
    popup: {
      header: "Термін дії пароля закінчився",
      text: "Вас буде перенаправлено на процес скидання пароля для встановлення нового.",
    },
    success: {
      header: "Пароль збережено",
      text: "Ваш пароль було змінено. Тепер ви можете перейти до додатку.",
    },
  },
  PsychologicalTests: {
    cognitive: "Когнітивні тести",
    personality: "Особистісні тести",
    psychomotor: "Психомоторні тести",
  },
  ResetPassword: {
    errorText:
      "Під час скидання пароля сталася помилка, будь ласка, спробуйте пізніше.",
    formHeader: "Скидання Пароля",
    resetEmailSentPt1: "На електронну адресу: ",
    resetEmailSentPt2:
      " надіслано повідомлення з інструкціями щодо процесу скидання пароля.",
    resetInfo:
      "Введіть електронну адресу вашого облікового запису, щоб отримати посилання для скидання пароля.",
    setNewPassword: "Встановити новий пароль",
    setNewPasswordInfo:
      "Введіть пароль, який ви будете використовувати для входу в систему.",
    success:
      "Ваш пароль було змінено. Тепер ви можете увійти в додаток, використовуючи свою електронну адресу та новий пароль.",
    successTitle: "Пароль Збережено",
  },
  SearchEngine: {
    enterFilter:
      "Ви можете шукати за ім'ям, прізвищем, номером ПЕСЕЛ/Ідентифікатором\nабо за датою призначення обстеження \nу форматі РРРР-ММ-ДД.",
    header: "Пошук обстежуваних",
    noResults: "Немає результатів пошуку",
    noResultsForFilter:
      "Не знайдено обстежуваних, що відповідають введеним вимогам.",
    placeholderDesktop:
      "Ім'я, прізвище, ПЕСЕЛ/Ідентифікатор, дата призначення обстеження (РРРР-ММ-ДД)",
    placeholderMobile: "Пошук",
    searchForExaminees: "Пошук обстежуваних",
  },
  RegistryResults: {
    header: "Реєстр обстежених",
    headerMobile: "Реєстр обстежених",
    clientAccounts: "Облікові записи клієнтів",
    clientAccountsRequired:
      "Потрібно вибрати принаймні один обліковий запис клієнта.",
    foldersRequired: "Виберіть принаймні одну папку.",
    legalBasisRequired: "Виберіть принаймні одну правову підставу обстеження.",
    folders: "Папки",
    dateFrom: "Дата від",
    dateTo: "Дата до",
    legalBasis: "Правові підстави",
    generateButton: "Генерувати реєстр",
    filesToDownload: "Файли для завантаження",
    filesRefresh: "Оновити список файлів",
    noFiles: "Немає згенерованих файлів.",
    exportSucceeded:
      "Запит на створення реєстру прийнято. Ви отримаєте електронний лист про завершення (успіх або помилка).",
    dateRangeError: "Дата «від» не може бути пізнішою за дату «до».",
    exportDeletedFileSucceeded: "Файл реєстру видалено.",
    popups: {
      delete: {
        confirmationHeader: "Ви впевнені, що хочете видалити файл реєстру?",
        confirmationText: "Після видалення файл реєстру не можна відновити.",
        confirmationCheckboxLabel: "Так, я хочу видалити файл реєстру",
      },
    },
  },
  PriceList: {
    header: "Прайс-лист",
    headerMobile: "Прайс-лист",
    testName: "Назва тесту",
    credits: "Кредити",
  },
  SendEmail: {
    header: "Надсилання сповіщень",
    headerMobile: "Надсилання сповіщень",
  },
  Snackbars: {
    createExaminationSuccess: "Обстеження успішно призначено",
    extendExaminationSuccess: "Обстеження успішно розширено новими тестами",
    recalculateExaminationSuccess: "Результати обстеження перераховано",
    createExamineeSuccess: "Обстежуваного успішно додано",
    createMultiExaminationSuccess:
      "Дослідження успішно імпортовані та призначені",
    createPsychLabSuccess: "Обліковий запис клієнта успішно додано",
    createPsychLicSuccess: "Ліцензію успішно додано",
    createPsychUserSuccess: "Користувача успішно додано",
    deleteExaminationSuccess: "Обстеження успішно видалено",
    anonymizePsychLabSuccess: "Дані клієнта успішно анонімізовано",
    anonymizePsychLabEmptySuccess:
      "Немає іспитів для анонімізації. Дані клієнта були очищені.",
    deletePsychLabSuccess: "Обліковий запис клієнта успішно видалено",
    editExamineeSuccess: "Обстежуваного успішно відредаговано",
    editPsychLabSuccess: "Обліковий запис клієнта успішно відредаговано",
    editPsychLicSuccess: "Ліцензію успішно відредаговано",
    editPsychUserSuccess: "Користувача успішно відредаговано",
    transferUserDataSuccess: "Обстеження та папки успішно перенесено",
    failedRequest: "Виникла проблема: ",
    movingExamineesSuccess: "Успішно переміщено до іншої папки",
    examineesListGeneratedSuccess: "Список обстежуваних успішно згенеровано",
    examineesListGeneratedError: "Не вдалося згенерувати список обстежуваних",
    deleteExamineeSuccess: "Обстежуваного успішно видалено",
    bulkDeleteExamineesSuccess: "Обстежуваних успішно видалено: %{deleted}",
    bulkDeleteExamineesPartial:
      "Видалено обстежуваних: %{deleted}. Пропущено (мають обстеження): %{skipped}",
    passwordChangeSuccess: "Пароль успішно змінено",
    pinChangeSuccess: "ПІН-код успішно змінено",
    success: "Дію виконано успішно",
    unrecognizedError: "Невизнана помилка, перевірте підключення до інтернету",
    editTestCreditSuccess: "Ціну тесту в кредитах успішно збережено",
    editTestCreditError: "Не вдалося зберегти ціну тесту в кредитах",
    unblockedExamSuccess: "Обстеження клієнта успішно розблоковано",
  },
  LandscapePrompt: {
    title: "Поверніть пристрій горизонтально",
    description:
      "Редагування документації недоступне в портретному режимі. Щоб продовжити, поверніть пристрій горизонтально.",
  },
  TwoFactor: {
    backupCode: "Резервний код",
    backupCodes: "Резервні коди",
    backupCodesInfo:
      "Збережіть ці резервні коди в безпечному місці. Ви можете використати їх для доступу до свого облікового запису, якщо втратите пристрій автентифікації.",
    confirmDisable: "Введіть пароль, щоб вимкнути двофакторну автентифікацію",
    disableError: "Не вдалося вимкнути двофакторну автентифікацію",
    disableSuccess: "Двофакторну автентифікацію успішно вимкнено",
    disableTitle: "Вимкнути двофакторну автентифікацію",
    enterBackupCode: "Введіть резервний код",
    enterCode: "Введіть код підтвердження з програми автентифікації",
    scanQRCode: "Відскануйте цей QR-код за допомогою програми автентифікації",
    secretKey: "Секретний ключ",
    setupError: "Не вдалося налаштувати двофакторну автентифікацію",
    setupSuccess: "Двофакторну автентифікацію успішно налаштовано",
    setupTitle: "Налаштувати двофакторну автентифікацію",
    useAuthenticator: "Використати автентифікатор",
    useBackupCode: "Використати резервний код",
    verificationCode: "Код підтвердження",
    verificationError: "Недійсний код підтвердження",
    verifyTitle: "Перевірити двофакторну автентифікацію",
  },
  UserSettings: {
    access: "Доступ",
    facilityInfo: "Інформація про заклад",
    header: "Налаштування облікового запису",
    headerChangePassword: "Зміна пароля",
    headerChangePin: "Зміна ПІН-коду",
    headerMobile: "Налаштування",
    helpdeskMsgLab:
      "Для зміни інформації про заклад або користувача зателефонуйте за номером:",
    helpdeskMsgUser:
      "Для зміни інформації про заклад або користувача зателефонуйте за номером:",
    infoSubHeaders: {
      address: "Адреса",
      cin: "Реєстраційний номер",
      dateExpire: "Дата закінчення облікового запису",
      email: "Електронна пошта",
      firstName: "Ім'я",
      id: "ID клієнта",
      labName: "Назва",
      lastName: "Прізвище",
      licenseNumber: "Номер ліцензії",
      assignedClientAccount: "Обліковий запис клієнта, до якого ви прив'язані",
      tin: "ІПН",
    },
    license: {
      license: "Ліцензія",
      dateLicExpire: "Дата закінчення терміну дії ліцензії: ",
      remainingCredits: "Кредити, що залишилися для використання: ",
      allCredits: "Придбані кредити: ",
      lockedCredits: "Кредити, заблоковані в обстеженнях: ",
      freeCredits: "Доступні кредити: ",
    },
    passwordChange: "Зміна пароля",
    passwordExpiry: "Термін дії вашого пароля закінчується: ",
    pinChange: "Зміна ПІН-коду",
    pinChangeMobile: "Зміна ПІН",
    pinInfo:
      "Введіть ПІН-код, який ви будете використовувати для входу в консоль психолога.",
    setNewPin: "Встановити новий ПІН-код",
    userInfo: "Інформація про користувача",
  },
  CsvHeaders: {
    firstName: "Ім'я",
    lastName: "Прізвище",
    identificationNumber: "Ідентифікатор",
    directoryName: "Назва папки",
  },
  CsvFileName: {
    examineesList: "список-обстежуваних",
  },
  SystemParams: {
    showBatteriesDesc:
      "прапорець, що вказує, чи відображати батареї при запрошенні на обстеження, значення: 0, 1",
    t2sTestsDesc:
      "список тестів, обраних за замовчуванням при виборі методології T2S, приклад значення: SIRT,CHORT,HECOR....",
    t2aTestsDesc:
      "список тестів, обраних за замовчуванням при виборі методології T2A, приклад значення: SIRT,CHORT,HECOR....",
    t2wTestsDesc:
      "список тестів, обраних за замовчуванням при виборі методології T2W, приклад значення: SIRT,CHORT,HECOR....",
    t2dTestsDesc:
      "список тестів, обраних за замовчуванням при виборі методології T2D, приклад значення: SIRT,CHORT,HECOR....",
    selectTestsDesc:
      "список тестів, обраних за замовчуванням при запрошенні без правової підстави, приклад значення: SIRT,CHORT,HECOR....",
    batteriesListDesc:
      "список батарей, видимий при запрошенні на обстеження, якщо параметр SHOW_BATTERIES встановлено на 1, приклад значення: TEST2DRIVE,TEST2SPORT...",
    showRecalculateExamDesc:
      "Чи показувати дію перерахунку обстеження у списку для адміністраторів лабораторії (is_admin), значення: 0, 1",
    showExtendedExamDesc:
      "Чи дозволяти розширювати закриті обстеження новими тестами, значення: 0, 1",
    showExamineeRegistryDesc:
      "Реєстр обстежуваних доступний з панелі психолога – чи відображати модуль реєстру обстежуваних, значення: 0, 1",
    showImportExamineeDesc:
      "Імпорт обстежуваних доступний з панелі психолога, значення: 0, 1",
    allowExportResultDesc:
      "Експорт результатів доступний з панелі психолога, значення: 0, 1",
    passwordExpiryDaysDesc:
      "Кількість днів дії пароля користувача (наприклад, 30, 60, 90)",
    allowDelExaminessDesc:
      "Чи дозволити одночасне видалення кількох обстежуваних, значення: 0, 1",
    allowDelExamineeWithExamDesc:
      "Чи дозволити видалення обстежуваного разом з його обстеженнями, значення: 0, 1",
    batteries: "Батарея",
  },
};